const translations = {
  en: {
    // App shell
    brandName: '{brandName}',
    version: '{brandName} Marketing v1.0',
    switchToArabic: 'Arabic',
    switchToEnglish: 'English',
    switchToLight: 'Switch to Light Mode',
    switchToDark: 'Switch to Dark Mode',
    toggleMenu: 'Toggle menu',

    // Sidebar nav
    navDashboard: 'Dashboard',
    navCampaigns: 'Campaigns',
    navSnapInsights: 'Snap Insights',
    navSnapchatAds: 'Snapchat Ads',
    navUnitsDeals: 'Units & Deals',
    navSettings: 'Settings',
    navAssistant: 'AI Assistant',

    // AI Assistant
    assistantTitle: 'AI Assistant',
    assistantIntro: 'Ask anything about your CRM data — leads, deals, sales performance, ad campaigns, reject reasons, and more.',
    assistantPlaceholder: 'Ask about your data…',
    assistantSend: 'Send',
    assistantThinking: 'Analyzing your data…',
    assistantClear: 'New chat',
    assistantError: 'Sorry, something went wrong. Please try again.',
    assistantNotConfigured: 'The AI assistant is not set up yet. An administrator needs to add an API key to enable it.',
    assistantDisclaimer: 'Answers are generated from your live database — double-check important figures.',
    assistantEnable: 'Enable the AI Assistant',
    assistantKeyHint: 'Paste your Anthropic API key. It is stored encrypted on the server and used only for this assistant.',
    assistantKeyPlaceholder: 'sk-ant-...',
    assistantSaveKey: 'Save key',
    assistantKeyInvalid: 'That does not look like a valid Anthropic key (it should start with "sk-ant-").',
    assistantKeyEnvNote: 'The key is set via the server environment and managed by your operations team.',
    assistantManageKey: 'Manage API key',
    assistantRemoveKey: 'Remove key',
    assistantContactAdmin: 'The AI assistant is not enabled yet. Ask an administrator to add an API key.',
    assistantGetKey: 'Get a key at console.anthropic.com',
    assistantHistory: 'Chats',
    assistantNoHistory: 'No saved chats yet',
    assistantDeleteChat: 'Delete chat',
    assistantSqlUsed: 'SQL used (verify the data)',

    // Page titles
    pageDashboard: 'Dashboard',
    pageCampaigns: 'Campaigns',
    pageSettings: 'Settings',
    pageUnitsDeals: 'Units & Deals',

    // Units & Deals
    udUnitsDeals: 'Units & Deals',
    udProject: 'Project',
    udUnit: 'Unit',
    udType: 'Type',
    udNeighborhood: 'Neighborhood',
    udPrice: 'Price',
    udStatus: 'Status',
    udClient: 'Client',
    udEarnest: 'Earnest Money',
    udEdit: 'Edit',
    udSalesChannel: 'Sales Channel',
    udDirect: 'Direct',
    udBroker: 'Broker',
    udMixed: 'Broker + Team',
    udCloser: 'Deal Closer',
    udMonth: 'Month',
    udQuarter: 'Quarter',
    udPayment: 'Payment Method',
    udRegisterDeal: 'Register Deal',
    udCommissionReport: 'Commission Report',
    udEarnestReport: 'Earnest Money Report',
    udMonthly: 'Monthly',
    udQuarterly: 'Quarterly',
    udAnnual: 'Annual',
    udStage: 'Deal Stage',
    udBrokerName: 'Broker Name',
    udBrokerPct: 'Commission %',
    pageSnapAds: 'Snapchat Ads',
    pageSnapHistory: 'Snapchat Insights',

    // Common
    loading: 'Loading...',
    loadError: "Couldn't load data",
    loadErrorHint: 'The server may be updating — please try again.',
    retry: 'Retry',
    loginServerDown: 'Server temporarily unavailable — please try again in a moment.',
    loginTooMany: 'Too many attempts — please wait a minute and try again.',
    refresh: 'Refresh',
    save: 'Save',
    close: 'Close',
    noData: 'No data available',
    to: 'to',
    error: 'error',
    prev: 'Prev',
    next: 'Next',
    refreshIn: 'Refresh in',
    custom: 'Custom',
    all: 'All',

    // Dashboard
    last7days: 'Last 7 days',
    last30days: 'Last 30 days',
    dashboardUpdated: 'Dashboard updated:',
    lastApiSync: 'Last API sync:',
    totalSpend: 'Total Spend',
    impressions: 'Impressions',
    clicks: 'Clicks',
    avgCTR: 'Avg CTR',
    conversions: 'Conversions',
    roas: 'ROAS',
    spendOverTime: 'Spend Over Time',
    impressionsVsClicks: 'Impressions vs Clicks',
    noTimeSeriesData: 'No time series data available',
    noCampaignData: 'No campaign data available',
    clarityAnalytics: 'Clarity Analytics',
    noDataYetSync: 'No data yet \u2014 sync from Settings',
    sessions: 'Sessions',
    bounceRate: 'Bounce Rate',
    rageClicks: 'Rage Clicks',
    deadClicks: 'Dead Clicks',
    scrollDepth: 'Scroll Depth',
    activeTime: 'Active Time',
    campaignBreakdown: 'Campaign Breakdown',
    campaign: 'Campaign',
    platform: 'Platform',
    spend: 'Spend',
    ctr: 'CTR',
    cpm: 'CPM',

    // Campaigns page
    allCampaigns: 'All Campaigns',
    days7: '7 days',
    days30: '30 days',
    allPlatforms: 'All Platforms',
    allStatus: 'All Status',
    active: 'Active',
    paused: 'Paused',
    campaignName: 'Campaign Name',
    status: 'Status',
    cpc: 'CPC',
    totalImpressions: 'Total Impressions',
    totalClicks: 'Total Clicks',
    totalConversions: 'Total Conversions',

    // Settings
    platformCredentials: 'Platform Credentials',
    credentialsDesc: 'Credentials are encrypted and stored in the database. The scheduler automatically syncs data every 15 minutes.',
    snapchatAds: 'Snapchat Ads',
    tiktokAds: 'TikTok Ads',
    microsoftClarity: 'Microsoft Clarity',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    refreshToken: 'Refresh Token',
    adAccountId: 'Ad Account ID',
    appId: 'App ID',
    secret: 'Secret',
    accessToken: 'Access Token',
    advertiserId: 'Advertiser ID',
    projectId: 'Project ID',
    apiKey: 'API Key',
    email: 'Email',
    password: 'Password',
    mode: 'Mode',
    apiKeyMode: 'API Key',
    loginFallback: 'Login Fallback',
    testAndSync: 'Test & Sync',
    syncNow: 'Sync Now',
    testing: 'Testing...',
    syncing: 'Syncing...',
    neverSynced: 'Never synced',
    syncFailed: 'Sync failed',
    show: 'Show',
    hide: 'Hide',
    clarityWarning: 'Clarity API access requires a paid plan. If you are on the free plan, use the login-based fallback. Clarity API is limited to 10 calls per project per day \u2014 the scheduler syncs every 3 hours.',
    enterClientId: 'Enter Client ID',
    enterClientSecret: 'Enter Client Secret',
    enterRefreshToken: 'Enter Refresh Token',
    enterAdAccountId: 'Enter Ad Account ID',
    enterAppId: 'Enter App ID',
    enterSecret: 'Enter Secret',
    enterAccessToken: 'Enter Access Token',
    enterAdvertiserId: 'Enter Advertiser ID',
    enterProjectId: 'Enter Project ID',
    enterApiKey: 'Enter API Key',
    enterEmail: 'Enter Email',
    enterPassword: 'Enter Password',

    // Yamam
    yamamTitle: 'Analytics Dashboard \u2014 {brandName}',
    yamamUniqueUsers: 'Total Unique Users',
    yamamAvgActiveTime: 'Average Active Time',
    yamamTotalSessions: 'Total Sessions',
    yamamReferrerPerf: 'Referrer Performance',
    yamamLoading: 'Loading...',
    yamamUsersByCity: 'Users by City',
    yamamReferrer: 'Referrer',
    yamamCountry: 'Country',
    yamamCity: 'City',
    yamamDirect: 'Direct',
    yamamTopPages: 'Most Visited Pages',
    yamamPage: 'Page',
    yamamSmartEvents: 'Smart Event Clicks',
    yamamEvent: 'Event',
    yamamClickCount: 'Clicks',
    yamamDevice: 'Device',
    yamamOS: 'Operating System',
    yamamAvgTime: 'Average Active Time',
    yamamInsights: 'Marketing Insights & Recommendations',
    yamamAnalyzing: 'Analyzing...',
    yamamNoInsights: 'Not enough data to generate insights. Sync data first.',
    yamamFooter: '{brandName} \u2014 Analytics Dashboard | Data from Microsoft Clarity | Auto-updated daily at 4:00 PM',
    yamamSyncSuccess: 'Sync successful \u2014',
    yamamSyncRecords: 'records',
    yamamSyncFailed: 'Sync failed',
    yamamSyncError: 'Sync error',
    yamamSeconds: 'seconds',
    yamamMinutes: 'minutes',

    // SnapAds
    snapAdsCampaigns: 'campaigns',
    snapAdsAllTime: 'All Time',
    snapAdsToday: 'Today',
    snapAdsYesterday: 'Yesterday',
    snapAdsLast7: 'Last 7 Days',
    snapAdsLast30: 'Last 30 Days',
    snapAdsCustom: 'Custom',
    snapAdsSyncNow: 'Sync Now',
    snapAdsRefresh: 'Refresh',
    snapAdsLoading: 'Loading data...',
    snapAdsTotalSpend: 'Total Spend',
    snapAdsImpressions: 'Impressions',
    snapAdsSwipeUps: 'Swipe Ups',
    snapAdsCTR: 'CTR',
    snapAdsAvgCPM: 'Avg CPM',
    snapAdsAvgCPC: 'Avg CPC',
    snapAdsVideoViews: 'Video Views',
    snapAdsActiveCampaigns: 'Active Campaigns',
    snapAdsDailySpend: 'Daily Spend Trend',
    snapAdsSpendDist: 'Spend Distribution',
    snapAdsNoDailyData: 'No daily data yet. Click "Sync Now" to fetch historical data.',
    snapAdsNoSpendData: 'No spend data',
    snapAdsCampaignsOverview: 'Campaigns Overview',
    snapAdsClickToDrill: 'Click any campaign to drill down',
    snapAdsCampaign: 'Campaign',
    snapAdsStatus: 'Status',
    snapAdsObjective: 'Objective',
    snapAdsSpend: 'Spend (SAR)',
    snapAdsCPM: 'CPM',
    snapAdsCPC: 'CPC',
    snapAdsStart: 'Start:',
    snapAdsEnd: 'End:',
    snapAdsOngoing: 'Ongoing',
    snapAdsBudget: 'Budget:',
    snapAdsAdSquads: 'Ad Squads',
    snapAdsFrequency: 'Frequency',
    snapAdsSyncStarted: 'Sync started in background...',

    // SnapHistory
    snapHistTitle: 'Snapchat Historical Insights',
    snapHistDeepDive: 'Deep Dive Portal',
    snapHistOverview: 'Overview',
    snapHistCampaigns: 'Campaigns',
    snapHistAdSquads: 'Ad Squads',
    snapHistTopAds: 'Top Ads',
    snapHistDailyTrends: 'Daily Trends',
    snapHistLoadingData: 'Loading Historical Data...',
    snapHistFetching: 'Fetching all Snapchat campaign data',
    snapHistFailed: 'Failed to load data',
    snapHistRetry: 'Retry',
    snapHistTotalSpend: 'Total Spend',
    snapHistTotalImpressions: 'Total Impressions',
    snapHistTotalSwipes: 'Total Swipes',
    snapHistOverallCTR: 'Overall CTR',
    snapHistAvgCPM: 'Avg CPM',
    snapHistAvgCPC: 'Avg CPC',
    snapHistVideoViews: 'Video Views',
    snapHistConversions: 'Conversions',
    snapHistTotalCampaigns: 'Total Campaigns',
    snapHistCampaignsWithSpend: 'Campaigns with Spend',
    snapHistSpendDist: 'Spend Distribution',
    snapHistSpendByCampaign: 'Spend by Campaign',
    snapHistEfficiency: 'Efficiency Comparison (CPM / CPC / CTR)',
    snapHistCampaignSummary: 'Campaign Summary',
    snapHistViewFullDetails: 'View Full Details',
    snapHistImpVsSwipes: 'Impressions vs Swipes',
    snapHistFreqVideo: 'Frequency & Video Views',
    snapHistAllCampaigns: 'All Campaigns Detail',
    snapHistTopAdSquadsBySpend: 'Top Ad Squads by Spend',
    snapHistAdSquadPerf: 'Ad Squad Performance',
    snapHistAdSquad: 'Ad Squad',
    snapHistBudgetDay: 'Budget/Day',
    snapHistTop15Ads: 'Top 15 Ads by Spend',
    snapHistAdPerfRankings: 'Ad Performance Rankings',
    snapHistViewFullAd: 'View Full Ad Details',
    snapHistAdName: 'Ad Name',
    snapHistType: 'Type',
    snapHistDailySpendTrend: 'Daily Spend Trend',
    snapHistNoDailyTrend: 'No daily trend data available. Sync data with daily granularity to see trends.',
    snapHistDailyImpSwipes: 'Daily Impressions & Swipes',
    snapHistDailyVideoViews: 'Daily Video Views',
    snapHistDailyBreakdown: 'Daily Breakdown',
    snapHistDate: 'Date',
    snapHistOpenPortal: 'Open Snapchat Ads Portal for Deep Dive',
    snapHistDrillDesc: 'Drill into individual campaigns, ad squads, ads, targeting, and lead forms',
    snapHistStart: 'Start',
    snapHistFreq: 'Freq',

    // Column tooltip hints
    // Executive Dashboard
    navExecutive: 'Executive',
    pageExecutive: 'Executive Dashboard',
    execTotalSpend: 'Total Ad Spend',
    execTotalImpressions: 'Total Impressions',
    execTotalClicks: 'Total Clicks',
    execTotalConversions: 'Total Conversions',
    execAvgCTR: 'Avg CTR',
    execAvgCPC: 'Avg CPC',
    execAvgCPM: 'Avg CPM',
    execPlatforms: 'Platforms Connected',
    execPlatformBreakdown: 'Platform Breakdown',
    execSpendDistribution: 'Spend Distribution',
    execSpendTrend: 'Daily Spend Trend',
    execWebAnalytics: 'Web Analytics',
    execUsers: 'Users',
    execSessions: 'Sessions',
    execAvgTime: 'Avg Active Time',
    execNotConnected: 'Not Connected',
    execConnectNow: 'Connect',
    execGoToSettings: 'Go to Settings',
    execComingSoon: 'Coming Soon',
    execNoData: 'No data for this period',
    execCampaigns: 'campaigns',
    execToday: 'Today',
    execYesterday: 'Yesterday',
    execLast3: 'Last 3 Days',
    execTotalLeads: 'Total Leads',
    execToday: 'Today',
    execAllTime: 'All Time',
    execCustom: 'Custom',
    execLast7: 'Last 7 Days',
    execLast30: 'Last 30 Days',
    execLastQuarter: 'Last 90 Days',
    execOf: 'of',
    execPerformanceSummary: 'Performance Summary',
    execChannelPerformance: 'Channel Performance',
    execCTRLabel: 'Click-Through Rate (CTR)',
    execCTRDesc: 'Percentage of people who clicked after seeing the ad',
    execCPCLabel: 'Cost Per Click (CPC)',
    execCPCDesc: 'Average cost for each click on the ad',
    execCPMLabel: 'Cost Per 1000 Views (CPM)',
    execCPMDesc: 'Cost for every 1,000 times the ad is shown',
    execNewLast24h: 'New (24h)',
    execConvDesc: 'Actions completed after clicking (form fills, purchases)',

    // CRM Leads
    navTodayTasks: "Today's Tasks",
    navLeads: 'Leads CRM',
    navAnalytics: 'Sales Analytics',

    // Analytics
    anPotential: 'Potential',
    anLost: 'Lost',
    anWorkedToday: 'Worked Today',
    anPostponed: 'Postponed',
    hintTotalLeads: 'Total number of leads created in the selected period',
    hintPotential: 'Leads with status: interested, site visit scheduled, offer sent, or negotiating (created in selected period)',
    hintWorked: 'Number of unique leads that had a status change by any team member in the selected period',
    hintVisitScheduled: 'Leads with a site visit scheduled for today',
    hintInterestedNoVisit: 'Leads marked as interested but no site visit date has been set yet',
    hintWon: 'Leads with status "won" (created in selected period)',
    hintNotInterested: 'Total leads with status "lost" across all time',
    hintPostponed: 'Leads with an overdue follow-up date that are not yet won or lost',
    anSalesPerformance: 'Sales Performance',
    anAvgResponse: 'Avg Response',
    anTodayFollowUps: "Today's Follow-ups",
    anTodayBreakdown: "Today's Activity",
    anSetContacted: 'Set Contacted',
    anSetInterested: 'Set Interested',
    anSetVisit: 'Set Visit',
    anSetLost: 'Set Lost',
    anPipeline: 'Pipeline',
    anBySource: 'By Source',
    anTeamComparison: 'Team Comparison',
    anWeeklyActivity: 'Weekly Activity (Leads/Day)',
    anMyProgress: 'My Progress',
    anPeriodToday: 'Today',
    anPeriodYesterday: 'Yesterday',
    anPeriodWeek: 'This Week',
    anPeriodMonth: 'This Month',
    anPeriodCustom: 'Custom',
    anDailyPerformance: "Today's Performance",
    anTotalTasks: 'Tasks',
    anCompleted: 'Done',
    anRemaining: 'Remaining',
    anTodayAssigned: 'Assigned',
    anEffortAssigned: 'Total leads',
    anEffortContacted: 'Ever contacted',
    anEffortAvgTouches: 'Avg touches/lead',
    anEffortOnceDropped: 'Contacted once & dropped',
    anStillOpen: 'Open',
    anEffortOutcome: 'Number of Calls & Their Outcomes',
    anEffortOutcomeHint: 'How many leads at each touch count are won, still open, or lost',
    anCommStatsTitle: 'Communication Activity per Rep',
    anCommStatsHint: 'Logged interactions this period, untouched leads, and avg calls to win vs lose',
    anCommsLogged: 'Logged',
    anCommsLeadsTouched: 'Leads touched',
    anSilentLeads: 'Silent leads',
    anNeverContacted: 'Never Contacted',
    hintNeverContacted: 'Assigned, still-open leads with no logged call or note yet \u2014 paid-for leads sitting completely untouched. Click to see them.',
    anAvgToWin: 'Avg \u2192 win',
    anAvgToLoss: 'Avg \u2192 loss',
    anTouchBreakdown: 'Contact-count breakdown',
    anTouchN1: 'Contacted once',
    anTouchN2: 'Contacted twice',
    anTouchN3: 'Contacted 3 times',
    anTouchN4: 'Contacted 4 times',
    anTouchN5: 'Contacted 5+ times',
    anKpiPerDay: 'KPI/day:',
    anTargetLabel: 'Target',
    anFollowupQuality: 'Follow-up Quality',
    anPipeline: 'Pipeline (total)',
    anTodayResults: "Today's Results",
    anNoWorkToday: 'No work logged today',
    anTodayBoard: 'Today',
    anAllReps: 'All reps',
    anLeft: 'left',
    anTodayDetail: "Today's Tasks",
    anCompletedTasks: 'Completed Tasks',
    anCompletedToday: 'Today',
    anCompletedPrevious: 'Earlier',
    anPendingTasks: 'Pending Tasks',
    anAllDone: 'All tasks completed!',
    anVisitScheduled: 'Visit Scheduled',
    anNotInterested: 'Not Interested',
    anInterestedNoVisit: 'Interested — No Visit',
    anLossReasons: 'Loss Reasons',
    anVisitLost: 'Visit → Lost',
    hintVisitLost: 'Leads that had a site visit scheduled and were marked lost in the selected period — visit fall-through / no-show signal',
    anStaleLeads: 'Stale Leads',
    anCommission: 'Team Commission',
    anRevenue: 'Revenue',
    anFunnel: 'Sales Funnel',
    anFunnelCumulative: 'Conversion Funnel',
    anFunnelCumulativeHint: 'Leads that ever reached each stage — with stage-to-stage conversion',
    anConversionOverall: 'Overall conversion',
    anConversionFromTop: 'of all leads',
    anConversionStep: 'step conversion',
    anWinRate: 'Win Rate by Source',
    hintStale: 'Active pipeline leads with no status change in 14+ days — deals quietly dying',
    hintCommission: 'Total team commission earned (closer + manager) from deals closed in the selected period',
    hintRevenue: 'Total deal value (actual price) for deals closed in the selected period',
    pageLeads: 'Leads CRM',
    crmAdmin: 'Admin',
    crmSales: 'Sales Member',
    crmKanbanView: 'Kanban',
    crmTableView: 'Table',
    crmAddLead: 'Add Lead',
    crmTotalLeads: 'Total Leads',
    crmNewLeads: 'New Leads',
    crmWonDeals: 'Won Deals',
    crmConversionRate: 'Conversion Rate',
    crmLeadName: 'Lead Name',
    crmPhone: 'Phone',
    crmEmail: 'Email',
    crmSource: 'Source',
    crmSnapchatType: 'Snapchat Type',
    crmSnapchatAqar: 'Aqar',
    crmSnapchatSiteVisit: 'Site Visit (زار المشروع)',
    crmSelectOption: '— Select —',
    crmCampaign: 'Campaign / Ad Name',
    crmProject: 'Project',
    crmBudget: 'Budget',
    crmNotes: 'Notes',
    crmContactHistory: 'Contact History',
    crmNotesHistory: 'Notes & History',
    crmNote: 'Note',
    crmAdCreative: 'Ad Creative',
    crmStatusLabel: 'Status',
    crmAssignedTo: 'Assigned To',
    crmCreatedAt: 'Date Received',
    crmCreatedBy: 'Created By',
    wizNoVisitReason: 'Reason for not visiting',
    wizNoVisitReasonPlaceholder: 'Why is the customer not visiting the project?',
    wizVisitHappened: 'Visit happened',
    wizVisitHappenedDesc: 'The customer visited the project',
    wizVisitMissed: "Visit didn't happen",
    wizVisitMissedDesc: 'The customer did not show up',
    wizCustomerOpinion: "Customer's opinion of the units",
    wizNextAction: 'Next action',
    wizRescheduleVisit: 'Reschedule visit',
    wizFollowUp: 'Follow up',
    crmLastUpdate: 'Last Update',
    crmFilterWorkedOn: 'Worked On',
    crmFilterToday: 'Today',
    crmFilterYesterday: 'Yesterday',
    crmFilterCustomDate: 'Custom Date',
    crmCreatedFrom: 'Created from',
    crmCreatedTo: 'Created to',
    crmFilterAllDates: 'All Dates',
    crmFilterSource: 'All Sources',
    crmFilterCampaign: 'All Campaigns',
    crmFilterStatus: 'All Statuses',
    crmFilterAssigned: 'All Members',
    crmTodayTasks: "Today's Tasks",
    crmMyPortfolio: 'My Portfolio',
    crmTodayActual: "Today's Work",
    crmBacklog: 'Pending',
    crmTodayTotal: 'Total Tasks',
    crmTodayNew: 'New Leads',
    crmTodayFollowUps: 'Follow-ups',
    crmTodayOverdue: 'Overdue Follow-ups',
    crmTodayBehind: 'Not Contacted',
    crmTodayBehindTitle: 'Never Contacted — Old Leads',
    crmTodayStaleTitle: 'Stale — No Next Action',
    crmTodayBehindHint: 'Leads assigned but never contacted',
    crmTouchesHint: 'Times contacted (logged interactions)',
    crmTodayOverdueHint: 'You set a follow-up date but it has passed',
    crmBehindScheduleWarning: 'These leads were assigned yesterday but not yet contacted!',
    crmTodayEmpty: 'No tasks for today — all caught up!',
    crmTodayOverdueTitle: 'Pending Follow-ups (overdue)',
    crmOverdueVisitsTitle: 'Pending Visits (overdue)',
    crmTodayOverdueTag: 'Overdue',
    crmTodayFollowUpTitle: "Today's Follow-ups",
    crmTodayFollowUpTag: 'Follow-up',
    crmTodayVisits: "Today's Visits",
    crmTodayVisitsTitle: "Site Visits Today",
    crmTodayNewTitle: 'New Leads to Contact',
    crmSearchPlaceholder: 'Search by name or phone...',
    crmSelected: 'selected',
    crmAssignTo: 'Assign to...',
    crmAssignBtn: 'Assign',
    crmClearSelection: 'Clear',
    crmClearFilters: 'Clear Filters',
    crmLeadDetails: 'Lead Details',
    crmCommunicationLog: 'Communication Log',
    crmAddNote: 'Type a note...',
    crmAddComm: 'Add',
    crmNoComms: 'No communication yet',
    crmSaveLead: 'Save',
    crmDeleteLead: 'Delete',
    crmStatusHistory: 'Status History',
    crmNoHistory: 'No status changes yet',
    crmBy: 'By',
    crmOutcome: 'Outcome',
    crmOutcome_interested: 'Interested',
    crmOutcome_not_interested: 'Not Interested',
    crmOutcome_not_answering: 'Not Answering',
    crmOfferedPrice: 'Offered Price',
    crmFinalPrice: 'Final Price',
    crmConfirmDelete: 'Are you sure you want to delete this lead?',
    crmYesDelete: 'Yes, Delete',
    crmCancel: 'Cancel',
    crmApprovalStatus: 'Approval',
    crmApproved: 'Approved',
    crmRejected: 'Rejected',
    crmPendingReview: 'Pending Review',
    crmApprove: 'Approve',
    crmReject: 'Reject',
    crmCommType_call: 'Call',
    crmCommType_whatsapp: 'WhatsApp',
    crmCommType_meeting: 'Meeting',
    crmCommType_note: 'Note',
    crmAnalytics: 'Analytics',
    crmSalesPerformance: 'Sales Performance',
    crmPotential: 'Potential',
    crmLostLabel: 'Lost',
    crmUnassigned: 'Unassigned',
    crmPotentialRate: 'Potential Rate',
    crmAvgResponse: 'Avg Response Time',
    crmContactedCount: 'Contacted',
    crmPipeline: 'Pipeline',
    crmBySource: 'By Source',
    crmMemberComparison: 'Team Comparison',

    crmLossReason: 'Reason for Loss',
    crmSelectReason: 'Select a reason...',
    crmLossReasonPrefix: 'Loss Reason',
    crmLossRequired: 'Please select a reason for marking as lost',
    crmLossPrice: 'Price too high',
    crmLossNoResponse: 'No response from customer',
    crmLossCompetitor: 'Chose a competitor',
    crmLossNotInterested: 'Not interested anymore',
    crmLossTiming: 'Bad timing',
    crmLossLocation: 'Location not suitable',
    crmLossOther: 'Other reason',
    crmLossOtherPlaceholder: 'Enter the reason...',
    crmLossDetailsPlaceholder: 'Add details about why this lead was lost...',

    crmStatus_new: 'New',
    crmStatus_contacted: 'Contacted',
    crmStatus_interested: 'Interested',
    crmStatus_site_visit_scheduled: 'Site Visit Scheduled',
    crmStatus_site_visit_done: 'Site Visit Done',
    crmStatus_offer_sent: 'Offer Sent',
    crmStatus_negotiating: 'Negotiating',
    crmStatus_won: 'Won',
    crmStatus_lost: 'Lost',

    // Status Transition Wizard
    wizTitle: 'Update Status',
    wizChooseOutcome: 'What was the outcome of the contact?',
    wizInterested: 'Interested',
    wizInterestedDesc: 'Customer showed interest in a project',
    wizNotAnswering: 'Not Answering / Call Later',
    wizNotAnsweringDesc: 'Schedule a follow-up call',
    wizNotInterested: 'Not Interested',
    wizNotInterestedDesc: 'Customer is not interested',
    wizWantsToBuy: 'Wants to Buy',
    wizWantsToBuyDesc: 'Ready to receive an offer',
    wizNeedsTime: 'Needs Time',
    wizNeedsTimeDesc: 'Interested but needs to think',
    wizDealWon: 'Deal Won',
    wizDealWonDesc: 'Close the deal successfully',
    wizContinueNegotiation: 'Continue Negotiation',
    wizContinueNegotiationDesc: 'Still negotiating terms',
    wizDealLost: 'Deal Lost',
    wizDealLostDesc: 'Customer decided not to proceed',
    wizSelectProject: 'Project',
    wizChooseProject: 'Choose a project...',
    wizProject_yamam7: 'Adwar – Yamam 7',
    wizProject_yamam8: 'Yamam 8',
    wizProject_yamamFlowers8: 'Yamam Flowers 8',
    wizProject_yamam9: 'Adwar – Yamam 9',
    wizProject_yamamPark10: 'Yamam Park 10',
    wizProject_yamamPark11: 'Yamam Park 11',
    wizProject_yamamFlowers12: 'Yamam Flowers 12',
    wizProject_yamam13: 'Townhouse – Yamam 13',
    wizProject_yamamPark14: 'Yamam Park 14',
    wizProject_yamam15: 'Adwar – Yamam 15',
    wizProject_yamam16: 'Adwar – Yamam 16',
    wizProject_yamam17: 'Adwar – Yamam 17',
    wizProject_yamam18: 'Townhouse – Yamam 18',
    wizProject_yamam19: 'Adwar – Yamam 19',
    wizProject_yamamFlowers: 'Yamam Flowers',
    wizProject_yamamPark: 'Yamam Park',
    wizProject_adwarTaawon: 'Adwar – Taawon',
    wizProject_adwarHiteen: 'Adwar – Hiteen',
    wizProject_other: 'Other',
    wizPaymentMethod: 'Payment Method',
    wizPayment_cash: 'Cash',
    wizPayment_bank: 'Bank Finance',
    wizPayment_installment: 'Installment',
    wizArrangeVisit: 'Arrange a site visit?',
    wizYes: 'Yes',
    wizNo: 'No',
    wizVisitDateTime: 'Visit Date & Time',
    wizFollowUpDate: 'Follow-up Date & Time',
    wizLossDetails: 'Details',
    wizOfferAmount: 'Offer Amount',
    wizOfferedPrice: 'Offered Price',
    wizCounterOffer: 'Counter Offer',
    wizFinalPrice: 'Final Price',
    wizUnitNumber: 'Unit Number',
    wizNextActionDate: 'Next Action Date',
    wizOutcome: 'Outcome',
    wizNewStatus: 'New Status',
    wizBack: 'Back',
    wizReview: 'Review',
    wizConfirm: 'Confirm',
    wizRequired: 'This field is required',
    wizStatusNote: 'Notes',
    wizStatusNotePlaceholder: 'Describe what happened with this lead...',
    wizUpdateStatus: 'Update Status',
    wizFollowUpDue: 'Follow-up is due!',
    wizFollowUpDueDesc: 'Please contact this lead and update the status below',
    wizFollowUpScheduled: 'Follow-up scheduled',

    // Channels
    navChannels: 'Ad Channels',
    pageChannels: 'Ad Channels',
    channel_snapchat: 'Snapchat',
    channel_tiktok: 'TikTok',
    channel_google: 'Google Ads',
    channel_instagram: 'Instagram',
    channel_x: 'X (Twitter)',
    channelComingSoonDesc: 'This integration is under development. Connect your account in Settings once available.',
    gadsKeywords: 'Keywords',
    gadsKeyword: 'Keyword',
    gadsMatchType: 'Match Type',
    gadsAdGroups: 'Ad Groups',
    gadsAdGroup: 'Ad Group',
    channelDemoData: 'Demo Data',
    channelDailySpend: 'Daily Spend Trend',
    channelCampaignPerf: 'Campaign Performance',
    channelReach: 'Reach',
    channelEngagement: 'Engagement',
    channelEngRate: 'Eng. Rate',
    channelLinkClicks: 'Link Clicks',
    channelSaves: 'Saves',
    channelShares: 'Shares',
    channelRetweets: 'Retweets',
    channelLikes: 'Likes',
    channelFollowers: 'New Followers',
    channelConvRate: 'Conv. Rate',
    channelQualityScore: 'Quality Score',
    channelType: 'Type',
    channelPlacement: 'Placement',
    channelObjective: 'Objective',
    channelCPE: 'CPE',
    channelClicksByCampaign: 'Clicks by Campaign',
    channelDailyReachEng: 'Daily Reach & Engagement',
    channelSpendByPlacement: 'Spend by Placement',
    channelDailyImpEng: 'Daily Impressions & Engagements',
    channelSpendByObjective: 'Spend by Objective',
    channelEngagements: 'Engagements',

    // Auth
    loginSubtitle: 'Sign in to your dashboard',
    loginEmail: 'Email',
    loginPassword: 'Password',
    loginButton: 'Sign In',
    logout: 'Logout',
    settingsUserManagement: 'User Management',
    settingsAddUser: 'Add User',
    settingsCreateUser: 'Create User',
    settingsUserCreated: 'User created successfully',
    settingsName: 'Name',
    settingsRole: 'Role',
    settingsRoleAdmin: 'Admin',
    settingsRoleManager: 'Manager',
    settingsRoleSales: 'Sales',
    settingsRoleBroker: 'Broker',
    settingsRoleViewer: 'Viewer',
    settingsLastLogin: 'Last Login',
    settingsTabEmployees: 'Employees',
    settingsTabBrokers: 'Brokers',
    settingsTabSocial: 'Social Media',
    settingsEmployeeManagement: 'Employee Management',
    settingsBrokerManagement: 'Broker Management',
    settingsAddBroker: 'Add Broker',
    settingsCreateBroker: 'Create Broker',
    settingsBrokerCreated: 'Broker user created successfully',
    settingsNoEmployees: 'No employees yet',
    settingsNoBrokers: 'No broker users yet',

    hintStatus: 'Whether the campaign is currently active, paused, or completed',
    hintObjective: 'The campaign goal such as awareness, traffic, or conversions',
    hintStart: 'The date when the campaign started running',
    hintImpressions: 'Total number of times the ad was displayed to users',
    hintSwipes: 'Number of swipe-ups (clicks) on the ad',
    hintSpend: 'Total amount spent on the campaign in SAR',
    hintCTR: 'Click-Through Rate — percentage of impressions that resulted in a swipe',
    hintCPM: 'Cost Per Mille — cost per 1,000 impressions',
    hintCPC: 'Cost Per Click — average cost for each swipe-up',
    hintFreq: 'Average number of times each user saw the ad',
    hintVideoViews: 'Total number of video views (2+ seconds watched)',

    // AI Report
    aiReportBtn: 'AI Report',
    aiGenerating: 'Generating...',

    // Leads Received KPI
    execLeadsReceived: 'Leads Received',
    execLeadsReceivedDesc: 'Total leads received in CRM from all sources',
    execCostPerLead: 'Cost/Lead',
  },

  ar: {
    // App shell
    brandName: '{brandName}',
    version: '{brandName} v1.0',
    switchToArabic: '\u0627\u0644\u0639\u0631\u0628\u064A\u0629',
    switchToEnglish: 'English',
    switchToLight: '\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u0641\u0627\u062A\u062D',
    switchToDark: '\u0627\u0644\u0648\u0636\u0639 \u0627\u0644\u062F\u0627\u0643\u0646',
    toggleMenu: '\u0642\u0627\u0626\u0645\u0629',

    // Sidebar nav
    navDashboard: '\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645',
    navCampaigns: '\u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    navSnapInsights: '\u0631\u0624\u0649 \u0633\u0646\u0627\u0628',
    navSnapchatAds: '\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0633\u0646\u0627\u0628',
    navUnitsDeals: '\u0627\u0644\u0648\u062D\u062F\u0627\u062A \u0648\u0627\u0644\u0635\u0641\u0642\u0627\u062A',
    navSettings: '\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A',
    navAssistant: '\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0630\u0643\u064A',

    // AI Assistant
    assistantTitle: '\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0630\u0643\u064A',
    assistantIntro: '\u0627\u0633\u0623\u0644 \u0623\u064A \u0633\u0624\u0627\u0644 \u0639\u0646 \u0628\u064A\u0627\u0646\u0627\u062A \u0646\u0638\u0627\u0645\u0643 \u2014 \u0627\u0644\u0639\u0645\u0644\u0627\u0621\u060C \u0627\u0644\u0635\u0641\u0642\u0627\u062A\u060C \u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A\u060C \u0627\u0644\u062D\u0645\u0644\u0627\u062A \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u064A\u0629\u060C \u0623\u0633\u0628\u0627\u0628 \u0627\u0644\u0631\u0641\u0636\u060C \u0648\u063A\u064A\u0631\u0647\u0627.',
    assistantPlaceholder: '\u0627\u0643\u062A\u0628 \u0633\u0624\u0627\u0644\u0643 \u0639\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A\u2026',
    assistantSend: '\u0625\u0631\u0633\u0627\u0644',
    assistantThinking: '\u064A\u062D\u0644\u0644 \u0628\u064A\u0627\u0646\u0627\u062A\u0643\u2026',
    assistantClear: '\u0645\u062D\u0627\u062F\u062B\u0629 \u062C\u062F\u064A\u062F\u0629',
    assistantError: '\u0639\u0630\u0631\u0627\u064B\u060C \u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627. \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649.',
    assistantNotConfigured: '\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0630\u0643\u064A \u063A\u064A\u0631 \u0645\u064F\u0641\u0639\u0651\u0644 \u0628\u0639\u062F. \u064A\u062D\u062A\u0627\u062C \u0627\u0644\u0645\u0634\u0631\u0641 \u0625\u0644\u0649 \u0625\u0636\u0627\u0641\u0629 \u0645\u0641\u062A\u0627\u062D \u0648\u0627\u062C\u0647\u0629 \u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u062A\u0637\u0628\u064A\u0642\u0627\u062A \u0644\u062A\u0641\u0639\u064A\u0644\u0647.',
    assistantDisclaimer: '\u062A\u064F\u0648\u0644\u0651\u062F \u0627\u0644\u0625\u062C\u0627\u0628\u0627\u062A \u0645\u0646 \u0642\u0627\u0639\u062F\u0629 \u0628\u064A\u0627\u0646\u0627\u062A\u0643 \u0627\u0644\u062D\u064A\u0629 \u2014 \u062A\u062D\u0642\u0651\u0642 \u0645\u0646 \u0627\u0644\u0623\u0631\u0642\u0627\u0645 \u0627\u0644\u0645\u0647\u0645\u0629.',
    assistantEnable: '\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0630\u0643\u064A',
    assistantKeyHint: '\u0627\u0644\u0635\u0642 \u0645\u0641\u062A\u0627\u062D Anthropic API \u0627\u0644\u062E\u0627\u0635 \u0628\u0643. \u064A\u064F\u062E\u0632\u064E\u0651\u0646 \u0645\u0634\u0641\u0651\u0631\u0627\u064B \u0639\u0644\u0649 \u0627\u0644\u062E\u0627\u062F\u0645 \u0648\u064A\u064F\u0633\u062A\u062E\u062F\u0645 \u0644\u0647\u0630\u0627 \u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0641\u0642\u0637.',
    assistantKeyPlaceholder: 'sk-ant-...',
    assistantSaveKey: '\u062D\u0641\u0638 \u0627\u0644\u0645\u0641\u062A\u0627\u062D',
    assistantKeyInvalid: '\u0647\u0630\u0627 \u0644\u0627 \u064A\u0628\u062F\u0648 \u0645\u0641\u062A\u0627\u062D Anthropic \u0635\u0627\u0644\u062D\u0627\u064B (\u064A\u062C\u0628 \u0623\u0646 \u064A\u0628\u062F\u0623 \u0628\u0640 "sk-ant-").',
    assistantKeyEnvNote: '\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0645\u064F\u0639\u064A\u064E\u0651\u0646 \u0639\u0628\u0631 \u0628\u064A\u0626\u0629 \u0627\u0644\u062E\u0627\u062F\u0645 \u0648\u064A\u064F\u062F\u0627\u0631 \u0645\u0646 \u0642\u0650\u0628\u0644 \u0641\u0631\u064A\u0642 \u0627\u0644\u062A\u0634\u063A\u064A\u0644 \u0644\u062F\u064A\u0643.',
    assistantManageKey: '\u0625\u062F\u0627\u0631\u0629 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0648\u0627\u062C\u0647\u0629',
    assistantRemoveKey: '\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0645\u0641\u062A\u0627\u062D',
    assistantContactAdmin: '\u0627\u0644\u0645\u0633\u0627\u0639\u062F \u0627\u0644\u0630\u0643\u064A \u063A\u064A\u0631 \u0645\u064F\u0641\u0639\u0651\u0644 \u0628\u0639\u062F. \u0627\u0637\u0644\u0628 \u0645\u0646 \u0627\u0644\u0645\u0634\u0631\u0641 \u0625\u0636\u0627\u0641\u0629 \u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0648\u0627\u062C\u0647\u0629.',
    assistantGetKey: '\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0645\u0641\u062A\u0627\u062D \u0645\u0646 console.anthropic.com',
    assistantHistory: '\u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0627\u062A',
    assistantNoHistory: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u062D\u0627\u062F\u062B\u0627\u062A \u0645\u062D\u0641\u0648\u0638\u0629',
    assistantDeleteChat: '\u062D\u0630\u0641 \u0627\u0644\u0645\u062D\u0627\u062F\u062B\u0629',
    assistantSqlUsed: '\u0627\u0644\u0627\u0633\u062A\u0639\u0644\u0627\u0645 \u0627\u0644\u0645\u064F\u0633\u062A\u062E\u062F\u0645 (\u0644\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A)',

    // Page titles
    pageDashboard: '\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645',
    pageCampaigns: '\u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    pageSettings: '\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A',
    pageUnitsDeals: '\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0648\u062D\u062F\u0627\u062A \u0648\u0627\u0644\u0635\u0641\u0642\u0627\u062A',

    // Units & Deals
    udUnitsDeals: '\u0627\u0644\u0648\u062D\u062F\u0627\u062A \u0648\u0627\u0644\u0635\u0641\u0642\u0627\u062A',
    udProject: '\u0627\u0644\u0645\u0634\u0631\u0648\u0639',
    udUnit: '\u0627\u0644\u0648\u062D\u062F\u0629',
    udType: '\u0627\u0644\u0646\u0648\u0639',
    udNeighborhood: '\u0627\u0644\u062D\u064A',
    udPrice: '\u0627\u0644\u0633\u0639\u0631',
    udStatus: '\u0627\u0644\u062D\u0627\u0644\u0629',
    udClient: '\u0627\u0644\u0639\u0645\u064A\u0644',
    udEarnest: '\u0627\u0644\u0639\u0631\u0628\u0648\u0646',
    udEdit: '\u062A\u0639\u062F\u064A\u0644',
    udSalesChannel: '\u0642\u0646\u0627\u0629 \u0627\u0644\u0628\u064A\u0639',
    udDirect: '\u0645\u0628\u0627\u0634\u0631',
    udBroker: '\u0648\u0633\u064A\u0637',
    udMixed: '\u0648\u0633\u064A\u0637+\u0641\u0631\u064A\u0642',
    udCloser: '\u0645\u0646\u0641\u0651\u0630 \u0627\u0644\u0635\u0641\u0642\u0629',
    udMonth: '\u0627\u0644\u0634\u0647\u0631',
    udQuarter: '\u0627\u0644\u0631\u0628\u0639',
    udPayment: '\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639',
    udRegisterDeal: '\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0635\u0641\u0642\u0629',
    udCommissionReport: '\u062A\u0642\u0631\u064A\u0631 \u0627\u0644\u0639\u0645\u0648\u0644\u0627\u062A',
    udEarnestReport: '\u062A\u0642\u0631\u064A\u0631 \u0627\u0644\u0639\u0631\u0628\u0648\u0646\u0627\u062A',
    udMonthly: '\u0634\u0647\u0631\u064A',
    udQuarterly: '\u0631\u0628\u0639\u064A',
    udAnnual: '\u0633\u0646\u0648\u064A',
    udStage: '\u0645\u0631\u062D\u0644\u0629 \u0627\u0644\u0635\u0641\u0642\u0629',
    udBrokerName: '\u0627\u0633\u0645 \u0627\u0644\u0648\u0633\u064A\u0637',
    udBrokerPct: '\u0627\u0644\u0646\u0633\u0628\u0629 %',
    pageSnapAds: '\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0633\u0646\u0627\u0628\u0634\u0627\u062A',
    pageSnapHistory: '\u0631\u0624\u0649 \u0633\u0646\u0627\u0628\u0634\u0627\u062A',

    // Common
    loading: '\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...',
    loadError: '\u062A\u0639\u0630\u0651\u0631 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A',
    loadErrorHint: '\u0642\u062F \u064A\u0643\u0648\u0646 \u0627\u0644\u062E\u0627\u062F\u0645 \u0642\u064A\u062F \u0627\u0644\u062A\u062D\u062F\u064A\u062B\u060C \u062D\u0627\u0648\u0644 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649',
    retry: '\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629',
    loginServerDown: '\u0627\u0644\u062E\u0627\u062F\u0645 \u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u0645\u0624\u0642\u062A\u0627\u064B\u060C \u062D\u0627\u0648\u0644 \u0628\u0639\u062F \u0644\u062D\u0638\u0627\u062A',
    loginTooMany: '\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0643\u062B\u064A\u0631\u0629\u060C \u0627\u0646\u062A\u0638\u0631 \u062F\u0642\u064A\u0642\u0629 \u062B\u0645 \u062D\u0627\u0648\u0644',
    refresh: '\u062A\u062D\u062F\u064A\u062B',
    save: '\u062D\u0641\u0638',
    close: '\u0625\u063A\u0644\u0627\u0642',
    noData: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A',
    to: '\u0625\u0644\u0649',
    error: '\u062E\u0637\u0623',
    prev: '\u0627\u0644\u0633\u0627\u0628\u0642',
    next: '\u0627\u0644\u062A\u0627\u0644\u064A',
    refreshIn: '\u062A\u062D\u062F\u064A\u062B \u062E\u0644\u0627\u0644',
    custom: '\u0645\u062E\u0635\u0635',
    all: '\u0627\u0644\u0643\u0644',

    // Dashboard
    last7days: '\u0622\u062E\u0631 7 \u0623\u064A\u0627\u0645',
    last30days: '\u0622\u062E\u0631 30 \u064A\u0648\u0645',
    dashboardUpdated: '\u062A\u0645 \u0627\u0644\u062A\u062D\u062F\u064A\u062B:',
    lastApiSync: '\u0622\u062E\u0631 \u0645\u0632\u0627\u0645\u0646\u0629:',
    totalSpend: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0625\u0646\u0641\u0627\u0642',
    impressions: '\u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631',
    clicks: '\u0627\u0644\u0646\u0642\u0631\u0627\u062A',
    avgCTR: '\u0645\u062A\u0648\u0633\u0637 \u0645\u0639\u062F\u0644 \u0627\u0644\u0646\u0642\u0631',
    conversions: '\u0627\u0644\u062A\u062D\u0648\u064A\u0644\u0627\u062A',
    roas: 'ROAS',
    spendOverTime: '\u0627\u0644\u0625\u0646\u0641\u0627\u0642 \u0639\u0628\u0631 \u0627\u0644\u0632\u0645\u0646',
    impressionsVsClicks: '\u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631 \u0645\u0642\u0627\u0628\u0644 \u0627\u0644\u0646\u0642\u0631\u0627\u062A',
    noTimeSeriesData: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0632\u0645\u0646\u064A\u0629',
    noCampaignData: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u062D\u0645\u0644\u0627\u062A',
    clarityAnalytics: '\u062A\u062D\u0644\u064A\u0644\u0627\u062A Clarity',
    noDataYetSync: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0628\u0639\u062F \u2014 \u0642\u0645 \u0628\u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629 \u0645\u0646 \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A',
    sessions: '\u0627\u0644\u062C\u0644\u0633\u0627\u062A',
    bounceRate: '\u0645\u0639\u062F\u0644 \u0627\u0644\u0627\u0631\u062A\u062F\u0627\u062F',
    rageClicks: '\u0646\u0642\u0631\u0627\u062A \u063A\u0627\u0636\u0628\u0629',
    deadClicks: '\u0646\u0642\u0631\u0627\u062A \u0645\u064A\u062A\u0629',
    scrollDepth: '\u0639\u0645\u0642 \u0627\u0644\u062A\u0645\u0631\u064A\u0631',
    activeTime: '\u0648\u0642\u062A \u0627\u0644\u062A\u0641\u0627\u0639\u0644',
    campaignBreakdown: '\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    campaign: '\u0627\u0644\u062D\u0645\u0644\u0629',
    platform: '\u0627\u0644\u0645\u0646\u0635\u0629',
    spend: '\u0627\u0644\u0625\u0646\u0641\u0627\u0642',
    ctr: '\u0645\u0639\u062F\u0644 \u0627\u0644\u0646\u0642\u0631',
    cpm: '\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0644\u0641 \u0638\u0647\u0648\u0631',

    // Campaigns page
    allCampaigns: '\u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    days7: '7 \u0623\u064A\u0627\u0645',
    days30: '30 \u064A\u0648\u0645',
    allPlatforms: '\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0646\u0635\u0627\u062A',
    allStatus: '\u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0627\u0644\u0627\u062A',
    active: '\u0646\u0634\u0637',
    paused: '\u0645\u062A\u0648\u0642\u0641',
    campaignName: '\u0627\u0633\u0645 \u0627\u0644\u062D\u0645\u0644\u0629',
    status: '\u0627\u0644\u062D\u0627\u0644\u0629',
    cpc: '\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0646\u0642\u0631\u0629',
    totalImpressions: '\u0625\u062C\u0645\u0627\u0644\u064A \u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631',
    totalClicks: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0646\u0642\u0631\u0627\u062A',
    totalConversions: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u062A\u062D\u0648\u064A\u0644\u0627\u062A',

    // Settings
    platformCredentials: '\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u0645\u0646\u0635\u0627\u062A',
    credentialsDesc: '\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0634\u0641\u0631\u0629 \u0648\u0645\u062E\u0632\u0646\u0629 \u0641\u064A \u0642\u0627\u0639\u062F\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A. \u064A\u062A\u0645 \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u0627\u064B \u0643\u0644 15 \u062F\u0642\u064A\u0642\u0629.',
    snapchatAds: '\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0633\u0646\u0627\u0628\u0634\u0627\u062A',
    tiktokAds: '\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u062A\u064A\u0643\u062A\u0648\u0643',
    microsoftClarity: 'Microsoft Clarity',
    clientId: '\u0645\u0639\u0631\u0641 \u0627\u0644\u0639\u0645\u064A\u0644',
    clientSecret: '\u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0633\u0631\u064A',
    refreshToken: '\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u062F\u064A\u062B',
    adAccountId: '\u0645\u0639\u0631\u0641 \u062D\u0633\u0627\u0628 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    appId: '\u0645\u0639\u0631\u0641 \u0627\u0644\u062A\u0637\u0628\u064A\u0642',
    secret: '\u0627\u0644\u0633\u0631',
    accessToken: '\u0631\u0645\u0632 \u0627\u0644\u0648\u0635\u0648\u0644',
    advertiserId: '\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0639\u0644\u0646',
    projectId: '\u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639',
    apiKey: '\u0645\u0641\u062A\u0627\u062D API',
    email: '\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A',
    password: '\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631',
    mode: '\u0627\u0644\u0648\u0636\u0639',
    apiKeyMode: '\u0645\u0641\u062A\u0627\u062D API',
    loginFallback: '\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644',
    testAndSync: '\u0627\u062E\u062A\u0628\u0627\u0631 \u0648\u0645\u0632\u0627\u0645\u0646\u0629',
    syncNow: '\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u0622\u0646',
    testing: '\u062C\u0627\u0631\u064D \u0627\u0644\u0627\u062E\u062A\u0628\u0627\u0631...',
    syncing: '\u062C\u0627\u0631\u064D \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629...',
    neverSynced: '\u0644\u0645 \u062A\u062A\u0645 \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629',
    syncFailed: '\u0641\u0634\u0644\u062A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629',
    show: '\u0625\u0638\u0647\u0627\u0631',
    hide: '\u0625\u062E\u0641\u0627\u0621',
    clarityWarning: '\u064A\u062A\u0637\u0644\u0628 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 Clarity API \u062E\u0637\u0629 \u0645\u062F\u0641\u0648\u0639\u0629. \u0625\u0630\u0627 \u0643\u0646\u062A \u0639\u0644\u0649 \u0627\u0644\u062E\u0637\u0629 \u0627\u0644\u0645\u062C\u0627\u0646\u064A\u0629\u060C \u0627\u0633\u062A\u062E\u062F\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0627\u0644\u0628\u062F\u064A\u0644. Clarity API \u0645\u062D\u062F\u0648\u062F \u0628\u0640 10 \u0637\u0644\u0628\u0627\u062A \u064A\u0648\u0645\u064A\u0627\u064B \u2014 \u064A\u062A\u0645 \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629 \u0643\u0644 3 \u0633\u0627\u0639\u0627\u062A.',
    enterClientId: '\u0623\u062F\u062E\u0644 \u0645\u0639\u0631\u0641 \u0627\u0644\u0639\u0645\u064A\u0644',
    enterClientSecret: '\u0623\u062F\u062E\u0644 \u0627\u0644\u0645\u0641\u062A\u0627\u062D \u0627\u0644\u0633\u0631\u064A',
    enterRefreshToken: '\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u062F\u064A\u062B',
    enterAdAccountId: '\u0623\u062F\u062E\u0644 \u0645\u0639\u0631\u0641 \u062D\u0633\u0627\u0628 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    enterAppId: '\u0623\u062F\u062E\u0644 \u0645\u0639\u0631\u0641 \u0627\u0644\u062A\u0637\u0628\u064A\u0642',
    enterSecret: '\u0623\u062F\u062E\u0644 \u0627\u0644\u0633\u0631',
    enterAccessToken: '\u0623\u062F\u062E\u0644 \u0631\u0645\u0632 \u0627\u0644\u0648\u0635\u0648\u0644',
    enterAdvertiserId: '\u0623\u062F\u062E\u0644 \u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0639\u0644\u0646',
    enterProjectId: '\u0623\u062F\u062E\u0644 \u0645\u0639\u0631\u0641 \u0627\u0644\u0645\u0634\u0631\u0648\u0639',
    enterApiKey: '\u0623\u062F\u062E\u0644 \u0645\u0641\u062A\u0627\u062D API',
    enterEmail: '\u0623\u062F\u062E\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A',
    enterPassword: '\u0623\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631',

    // Yamam
    yamamTitle: '\u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u2014 {brandName}',
    yamamUniqueUsers: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646 \u0627\u0644\u0641\u0631\u064A\u062F\u064A\u0646',
    yamamAvgActiveTime: '\u0645\u062A\u0648\u0633\u0637 \u0648\u0642\u062A \u0627\u0644\u062A\u0641\u0627\u0639\u0644',
    yamamTotalSessions: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u062C\u0644\u0633\u0627\u062A',
    yamamReferrerPerf: '\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u0635\u0627\u062F\u0631',
    yamamLoading: '\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0645\u064A\u0644...',
    yamamUsersByCity: '\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646 \u062D\u0633\u0628 \u0627\u0644\u0645\u062F\u064A\u0646\u0629',
    yamamReferrer: '\u0627\u0644\u0645\u0635\u062F\u0631',
    yamamCountry: '\u0627\u0644\u062F\u0648\u0644\u0629',
    yamamCity: '\u0627\u0644\u0645\u062F\u064A\u0646\u0629',
    yamamDirect: '\u0645\u0628\u0627\u0634\u0631',
    yamamTopPages: '\u0623\u0643\u062B\u0631 \u0627\u0644\u0635\u0641\u062D\u0627\u062A \u0632\u064A\u0627\u0631\u0629',
    yamamPage: '\u0627\u0644\u0635\u0641\u062D\u0629',
    yamamSmartEvents: '\u0646\u0642\u0631\u0627\u062A \u0627\u0644\u0623\u062D\u062F\u0627\u062B \u0627\u0644\u0630\u0643\u064A\u0629',
    yamamEvent: '\u0627\u0644\u062D\u062F\u062B',
    yamamClickCount: '\u0627\u0644\u0646\u0642\u0631\u0627\u062A',
    yamamDevice: '\u0627\u0644\u062C\u0647\u0627\u0632',
    yamamOS: '\u0646\u0638\u0627\u0645 \u0627\u0644\u062A\u0634\u063A\u064A\u0644',
    yamamAvgTime: '\u0645\u062A\u0648\u0633\u0637 \u0648\u0642\u062A \u0627\u0644\u062A\u0641\u0627\u0639\u0644',
    yamamInsights: '\u0631\u0624\u0649 \u0648\u062A\u0648\u0635\u064A\u0627\u062A \u062A\u0633\u0648\u064A\u0642\u064A\u0629',
    yamamAnalyzing: '\u062C\u0627\u0631\u064D \u0627\u0644\u062A\u062D\u0644\u064A\u0644...',
    yamamNoInsights: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0643\u0627\u0641\u064A\u0629 \u0644\u062A\u0648\u0644\u064A\u062F \u0627\u0644\u0631\u0624\u0649. \u0642\u0645 \u0628\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0623\u0648\u0644\u0627\u064B.',
    yamamFooter: '{brandName} \u2014 \u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A | \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0645\u0646 Microsoft Clarity | \u062A\u062D\u062F\u064A\u062B \u062A\u0644\u0642\u0627\u0626\u064A \u064A\u0648\u0645\u064A\u0627\u064B \u0627\u0644\u0633\u0627\u0639\u0629 \u0664:\u0660\u0660 \u0645\u0633\u0627\u0621\u064B',
    yamamSyncSuccess: '\u062A\u0645 \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629 \u0628\u0646\u062C\u0627\u062D \u2014',
    yamamSyncRecords: '\u0633\u062C\u0644',
    yamamSyncFailed: '\u0641\u0634\u0644\u062A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629',
    yamamSyncError: '\u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629',
    yamamSeconds: '\u062B\u0627\u0646\u064A\u0629',
    yamamMinutes: '\u062F\u0642\u064A\u0642\u0629',

    // SnapAds
    snapAdsCampaigns: '\u062D\u0645\u0644\u0629',
    snapAdsAllTime: '\u0643\u0644 \u0627\u0644\u0648\u0642\u062A',
    snapAdsToday: '\u0627\u0644\u064A\u0648\u0645',
    snapAdsYesterday: '\u0623\u0645\u0633',
    snapAdsLast7: '\u0622\u062E\u0631 7 \u0623\u064A\u0627\u0645',
    snapAdsLast30: '\u0622\u062E\u0631 30 \u064A\u0648\u0645',
    snapAdsCustom: '\u0645\u062E\u0635\u0635',
    snapAdsSyncNow: '\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u0622\u0646',
    snapAdsRefresh: '\u062A\u062D\u062F\u064A\u062B',
    snapAdsLoading: '\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A...',
    snapAdsTotalSpend: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0625\u0646\u0641\u0627\u0642',
    snapAdsImpressions: '\u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631',
    snapAdsSwipeUps: '\u0627\u0644\u0633\u062D\u0628 \u0644\u0644\u0623\u0639\u0644\u0649',
    snapAdsCTR: '\u0645\u0639\u062F\u0644 \u0627\u0644\u0646\u0642\u0631',
    snapAdsAvgCPM: '\u0645\u062A\u0648\u0633\u0637 \u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0644\u0641 \u0638\u0647\u0648\u0631',
    snapAdsAvgCPC: '\u0645\u062A\u0648\u0633\u0637 \u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0646\u0642\u0631\u0629',
    snapAdsVideoViews: '\u0645\u0634\u0627\u0647\u062F\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648',
    snapAdsActiveCampaigns: '\u0627\u0644\u062D\u0645\u0644\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629',
    snapAdsDailySpend: '\u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0625\u0646\u0641\u0627\u0642 \u0627\u0644\u064A\u0648\u0645\u064A',
    snapAdsSpendDist: '\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0625\u0646\u0641\u0627\u0642',
    snapAdsNoDailyData: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u064A\u0648\u0645\u064A\u0629. \u0627\u0646\u0642\u0631 "\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u0622\u0646" \u0644\u062C\u0644\u0628 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A.',
    snapAdsNoSpendData: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0625\u0646\u0641\u0627\u0642',
    snapAdsCampaignsOverview: '\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629 \u0639\u0644\u0649 \u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    snapAdsClickToDrill: '\u0627\u0646\u0642\u0631 \u0639\u0644\u0649 \u0623\u064A \u062D\u0645\u0644\u0629 \u0644\u0644\u062A\u0641\u0627\u0635\u064A\u0644',
    snapAdsCampaign: '\u0627\u0644\u062D\u0645\u0644\u0629',
    snapAdsStatus: '\u0627\u0644\u062D\u0627\u0644\u0629',
    snapAdsObjective: '\u0627\u0644\u0647\u062F\u0641',
    snapAdsSpend: '\u0627\u0644\u0625\u0646\u0641\u0627\u0642 (SAR)',
    snapAdsCPM: '\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0644\u0641 \u0638\u0647\u0648\u0631',
    snapAdsCPC: '\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0646\u0642\u0631\u0629',
    snapAdsStart: '\u0627\u0644\u0628\u062F\u0627\u064A\u0629:',
    snapAdsEnd: '\u0627\u0644\u0646\u0647\u0627\u064A\u0629:',
    snapAdsOngoing: '\u0645\u0633\u062A\u0645\u0631\u0629',
    snapAdsBudget: '\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629:',
    snapAdsAdSquads: '\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    snapAdsFrequency: '\u0627\u0644\u062A\u0643\u0631\u0627\u0631',
    snapAdsSyncStarted: '\u0628\u062F\u0623\u062A \u0627\u0644\u0645\u0632\u0627\u0645\u0646\u0629 \u0641\u064A \u0627\u0644\u062E\u0644\u0641\u064A\u0629...',

    // SnapHistory
    snapHistTitle: '\u0631\u0624\u0649 \u0633\u0646\u0627\u0628\u0634\u0627\u062A \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u064A\u0629',
    snapHistDeepDive: '\u0628\u0648\u0627\u0628\u0629 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644',
    snapHistOverview: '\u0646\u0638\u0631\u0629 \u0639\u0627\u0645\u0629',
    snapHistCampaigns: '\u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    snapHistAdSquads: '\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    snapHistTopAds: '\u0623\u0641\u0636\u0644 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    snapHistDailyTrends: '\u0627\u0644\u0627\u062A\u062C\u0627\u0647\u0627\u062A \u0627\u0644\u064A\u0648\u0645\u064A\u0629',
    snapHistLoadingData: '\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0627\u0644\u062A\u0627\u0631\u064A\u062E\u064A\u0629...',
    snapHistFetching: '\u062C\u0644\u0628 \u062C\u0645\u064A\u0639 \u0628\u064A\u0627\u0646\u0627\u062A \u062D\u0645\u0644\u0627\u062A \u0633\u0646\u0627\u0628\u0634\u0627\u062A',
    snapHistFailed: '\u0641\u0634\u0644 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A',
    snapHistRetry: '\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629',
    snapHistTotalSpend: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0625\u0646\u0641\u0627\u0642',
    snapHistTotalImpressions: '\u0625\u062C\u0645\u0627\u0644\u064A \u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631',
    snapHistTotalSwipes: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0633\u062D\u0628',
    snapHistOverallCTR: '\u0645\u0639\u062F\u0644 \u0627\u0644\u0646\u0642\u0631 \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A',
    snapHistAvgCPM: '\u0645\u062A\u0648\u0633\u0637 \u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0644\u0641 \u0638\u0647\u0648\u0631',
    snapHistAvgCPC: '\u0645\u062A\u0648\u0633\u0637 \u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0646\u0642\u0631\u0629',
    snapHistVideoViews: '\u0645\u0634\u0627\u0647\u062F\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648',
    snapHistConversions: '\u0627\u0644\u062A\u062D\u0648\u064A\u0644\u0627\u062A',
    snapHistTotalCampaigns: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    snapHistCampaignsWithSpend: '\u062D\u0645\u0644\u0627\u062A \u0628\u0625\u0646\u0641\u0627\u0642',
    snapHistSpendDist: '\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0625\u0646\u0641\u0627\u0642',
    snapHistSpendByCampaign: '\u0627\u0644\u0625\u0646\u0641\u0627\u0642 \u062D\u0633\u0628 \u0627\u0644\u062D\u0645\u0644\u0629',
    snapHistEfficiency: '\u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u0643\u0641\u0627\u0621\u0629 (\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0644\u0641 / \u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0646\u0642\u0631\u0629 / \u0645\u0639\u062F\u0644 \u0627\u0644\u0646\u0642\u0631)',
    snapHistCampaignSummary: '\u0645\u0644\u062E\u0635 \u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    snapHistViewFullDetails: '\u0639\u0631\u0636 \u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0643\u0627\u0645\u0644\u0629',
    snapHistImpVsSwipes: '\u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631 \u0645\u0642\u0627\u0628\u0644 \u0627\u0644\u0633\u062D\u0628',
    snapHistFreqVideo: '\u0627\u0644\u062A\u0643\u0631\u0627\u0631 \u0648\u0645\u0634\u0627\u0647\u062F\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648',
    snapHistAllCampaigns: '\u062A\u0641\u0627\u0635\u064A\u0644 \u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    snapHistTopAdSquadsBySpend: '\u0623\u0641\u0636\u0644 \u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0625\u0639\u0644\u0627\u0646\u064A\u0629 \u062D\u0633\u0628 \u0627\u0644\u0625\u0646\u0641\u0627\u0642',
    snapHistAdSquadPerf: '\u0623\u062F\u0627\u0621 \u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    snapHistAdSquad: '\u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    snapHistBudgetDay: '\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629/\u064A\u0648\u0645',
    snapHistTop15Ads: '\u0623\u0641\u0636\u0644 15 \u0625\u0639\u0644\u0627\u0646 \u062D\u0633\u0628 \u0627\u0644\u0625\u0646\u0641\u0627\u0642',
    snapHistAdPerfRankings: '\u062A\u0631\u062A\u064A\u0628 \u0623\u062F\u0627\u0621 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    snapHistViewFullAd: '\u0639\u0631\u0636 \u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0627\u0644\u0643\u0627\u0645\u0644\u0629',
    snapHistAdName: '\u0627\u0633\u0645 \u0627\u0644\u0625\u0639\u0644\u0627\u0646',
    snapHistType: '\u0627\u0644\u0646\u0648\u0639',
    snapHistDailySpendTrend: '\u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0625\u0646\u0641\u0627\u0642 \u0627\u0644\u064A\u0648\u0645\u064A',
    snapHistNoDailyTrend: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0627\u062A\u062C\u0627\u0647 \u064A\u0648\u0645\u064A. \u0642\u0645 \u0628\u0645\u0632\u0627\u0645\u0646\u0629 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0639\u0631\u0636 \u0627\u0644\u0627\u062A\u062C\u0627\u0647\u0627\u062A.',
    snapHistDailyImpSwipes: '\u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631 \u0648\u0627\u0644\u0633\u062D\u0628 \u0627\u0644\u064A\u0648\u0645\u064A',
    snapHistDailyVideoViews: '\u0645\u0634\u0627\u0647\u062F\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648 \u0627\u0644\u064A\u0648\u0645\u064A\u0629',
    snapHistDailyBreakdown: '\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u064A\u0648\u0645\u064A\u0629',
    snapHistDate: '\u0627\u0644\u062A\u0627\u0631\u064A\u062E',
    snapHistOpenPortal: '\u0641\u062A\u062D \u0628\u0648\u0627\u0628\u0629 \u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0633\u0646\u0627\u0628\u0634\u0627\u062A \u0644\u0644\u062A\u0641\u0627\u0635\u064A\u0644',
    snapHistDrillDesc: '\u0627\u0633\u062A\u0639\u0631\u0636 \u0627\u0644\u062D\u0645\u0644\u0627\u062A \u0648\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u0627\u0633\u062A\u0647\u062F\u0627\u0641 \u0648\u0646\u0645\u0627\u0630\u062C \u0627\u0644\u0639\u0645\u0644\u0627\u0621',
    snapHistStart: '\u0627\u0644\u0628\u062F\u0627\u064A\u0629',
    snapHistFreq: '\u0627\u0644\u062A\u0643\u0631\u0627\u0631',

    // Column tooltip hints
    // Executive Dashboard
    navExecutive: '\u0627\u0644\u062A\u0646\u0641\u064A\u0630\u064A',
    pageExecutive: '\u0644\u0648\u062D\u0629 \u0627\u0644\u0642\u064A\u0627\u062F\u0629 \u0627\u0644\u062A\u0646\u0641\u064A\u0630\u064A\u0629',
    execTotalSpend: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0625\u0646\u0641\u0627\u0642 \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u064A',
    execTotalImpressions: '\u0625\u062C\u0645\u0627\u0644\u064A \u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631',
    execTotalClicks: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0646\u0642\u0631\u0627\u062A',
    execTotalConversions: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u062A\u062D\u0648\u064A\u0644\u0627\u062A',
    execAvgCTR: '\u0645\u062A\u0648\u0633\u0637 \u0645\u0639\u062F\u0644 \u0627\u0644\u0646\u0642\u0631',
    execAvgCPC: '\u0645\u062A\u0648\u0633\u0637 \u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0646\u0642\u0631\u0629',
    execAvgCPM: '\u0645\u062A\u0648\u0633\u0637 \u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0623\u0644\u0641 \u0638\u0647\u0648\u0631',
    execPlatforms: '\u0627\u0644\u0645\u0646\u0635\u0627\u062A \u0627\u0644\u0645\u062A\u0635\u0644\u0629',
    execPlatformBreakdown: '\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0645\u0646\u0635\u0627\u062A',
    execSpendDistribution: '\u062A\u0648\u0632\u064A\u0639 \u0627\u0644\u0625\u0646\u0641\u0627\u0642',
    execSpendTrend: '\u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0625\u0646\u0641\u0627\u0642 \u0627\u0644\u064A\u0648\u0645\u064A',
    execWebAnalytics: '\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u0648\u0642\u0639',
    execUsers: '\u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u0648\u0646',
    execSessions: '\u0627\u0644\u062C\u0644\u0633\u0627\u062A',
    execAvgTime: '\u0645\u062A\u0648\u0633\u0637 \u0648\u0642\u062A \u0627\u0644\u062A\u0641\u0627\u0639\u0644',
    execNotConnected: '\u063A\u064A\u0631 \u0645\u062A\u0635\u0644',
    execConnectNow: '\u0631\u0628\u0637',
    execGoToSettings: '\u0627\u0644\u0630\u0647\u0627\u0628 \u0644\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A',
    execComingSoon: '\u0642\u0631\u064A\u0628\u0627\u064B',
    execNoData: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0647\u0630\u0647 \u0627\u0644\u0641\u062A\u0631\u0629',
    execCampaigns: '\u062D\u0645\u0644\u0629',
    execToday: '\u0627\u0644\u064A\u0648\u0645',
    execYesterday: '\u0623\u0645\u0633',
    execLast3: '\u0622\u062E\u0631 3 \u0623\u064A\u0627\u0645',
    execTotalLeads: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0639\u0645\u0644\u0627\u0621',
    execToday: '\u0627\u0644\u064A\u0648\u0645',
    execAllTime: '\u0643\u0644 \u0627\u0644\u0648\u0642\u062A',
    execCustom: '\u0645\u062E\u0635\u0635',
    execLast7: '\u0622\u062E\u0631 7 \u0623\u064A\u0627\u0645',
    execLast30: '\u0622\u062E\u0631 30 \u064A\u0648\u0645',
    execLastQuarter: '\u0622\u062E\u0631 90 \u064A\u0648\u0645',
    execOf: '\u0645\u0646',
    execCTRLabel: '\u0645\u0639\u062F\u0644 \u0627\u0644\u0646\u0642\u0631 (CTR)',
    execCTRDesc: '\u0646\u0633\u0628\u0629 \u0627\u0644\u0623\u0634\u062E\u0627\u0635 \u0627\u0644\u0630\u064A\u0646 \u0646\u0642\u0631\u0648\u0627 \u0628\u0639\u062F \u0645\u0634\u0627\u0647\u062F\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646',
    execCPCLabel: '\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u0646\u0642\u0631\u0629 (CPC)',
    execCPCDesc: '\u0645\u062A\u0648\u0633\u0637 \u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0644\u0643\u0644 \u0646\u0642\u0631\u0629 \u0639\u0644\u0649 \u0627\u0644\u0625\u0639\u0644\u0627\u0646',
    execCPMLabel: '\u062A\u0643\u0644\u0641\u0629 \u0644\u0643\u0644 1000 \u0645\u0634\u0627\u0647\u062F\u0629 (CPM)',
    execCPMDesc: '\u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0644\u0643\u0644 1000 \u0645\u0631\u0629 \u064A\u0638\u0647\u0631 \u0641\u064A\u0647\u0627 \u0627\u0644\u0625\u0639\u0644\u0627\u0646',
    execNewLast24h: '\u062C\u062F\u064A\u062F (24 \u0633\u0627\u0639\u0629)',
    execConvDesc: '\u0627\u0644\u0625\u062C\u0631\u0627\u0621\u0627\u062A \u0627\u0644\u0645\u0643\u062A\u0645\u0644\u0629 \u0628\u0639\u062F \u0627\u0644\u0646\u0642\u0631 (\u062A\u0639\u0628\u0626\u0629 \u0646\u0645\u0627\u0630\u062C\u060C \u0645\u0634\u062A\u0631\u064A\u0627\u062A)',
    execPerformanceSummary: '\u0645\u0644\u062E\u0635 \u0627\u0644\u0623\u062F\u0627\u0621',
    execChannelPerformance: '\u0623\u062F\u0627\u0621 \u0627\u0644\u0642\u0646\u0648\u0627\u062A',

    // CRM Leads
    navTodayTasks: '\u0645\u0647\u0627\u0645 \u0627\u0644\u064A\u0648\u0645',
    navLeads: '\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621',
    navAnalytics: '\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A',

    // Analytics
    anPotential: '\u0645\u062D\u062A\u0645\u0644',
    anLost: '\u062E\u0627\u0633\u0631',
    anWorkedToday: '\u0639\u0645\u0644 \u0627\u0644\u064A\u0648\u0645',
    anPostponed: '\u0645\u0624\u062C\u0644',
    hintTotalLeads: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0630\u064A\u0646 \u062A\u0645 \u0625\u0646\u0634\u0627\u0624\u0647\u0645 \u0641\u064A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629',
    hintPotential: '\u0639\u0645\u0644\u0627\u0621 \u0628\u062D\u0627\u0644\u0629: \u0645\u0647\u062A\u0645\u060C \u0632\u064A\u0627\u0631\u0629 \u0645\u062C\u062F\u0648\u0644\u0629\u060C \u0639\u0631\u0636 \u0645\u0631\u0633\u0644\u060C \u0623\u0648 \u062A\u0641\u0627\u0648\u0636 (\u0641\u064A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629)',
    hintWorked: '\u0639\u062F\u062F \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0630\u064A\u0646 \u062A\u0645 \u062A\u063A\u064A\u064A\u0631 \u062D\u0627\u0644\u062A\u0647\u0645 \u0645\u0646 \u0642\u0628\u0644 \u0623\u064A \u0639\u0636\u0648 \u0641\u064A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629',
    hintVisitScheduled: '\u0639\u0645\u0644\u0627\u0621 \u0644\u062F\u064A\u0647\u0645 \u0632\u064A\u0627\u0631\u0629 \u0645\u0648\u0642\u0639 \u0645\u062C\u062F\u0648\u0644\u0629 \u0627\u0644\u064A\u0648\u0645',
    hintInterestedNoVisit: '\u0639\u0645\u0644\u0627\u0621 \u0645\u0647\u062A\u0645\u0648\u0646 \u0644\u0643\u0646 \u0644\u0645 \u064A\u062A\u0645 \u062A\u062D\u062F\u064A\u062F \u0645\u0648\u0639\u062F \u0632\u064A\u0627\u0631\u0629 \u0628\u0639\u062F',
    hintWon: '\u0639\u0645\u0644\u0627\u0621 \u0628\u062D\u0627\u0644\u0629 "\u0645\u0643\u0633\u0628" (\u0641\u064A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629)',
    hintNotInterested: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0628\u062D\u0627\u0644\u0629 "\u062E\u0633\u0627\u0631\u0629" \u0639\u0644\u0649 \u0645\u062F\u0627\u0631 \u0643\u0644 \u0627\u0644\u0641\u062A\u0631\u0627\u062A',
    hintPostponed: '\u0639\u0645\u0644\u0627\u0621 \u0644\u062F\u064A\u0647\u0645 \u0645\u0648\u0639\u062F \u0645\u062A\u0627\u0628\u0639\u0629 \u0645\u062A\u0623\u062E\u0631 \u0648\u0644\u0645 \u064A\u062A\u0645 \u0625\u063A\u0644\u0627\u0642\u0647\u0645 \u0628\u0639\u062F',
    anSalesPerformance: '\u0623\u062F\u0627\u0621 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A',
    anAvgResponse: '\u0645\u062A\u0648\u0633\u0637 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629',
    anTodayFollowUps: '\u0645\u062A\u0627\u0628\u0639\u0627\u062A \u0627\u0644\u064A\u0648\u0645',
    anTodayBreakdown: '\u0646\u0634\u0627\u0637 \u0627\u0644\u064A\u0648\u0645',
    anSetContacted: '\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644',
    anSetInterested: '\u0645\u0647\u062A\u0645',
    anSetVisit: '\u0632\u064A\u0627\u0631\u0629',
    anSetLost: '\u062E\u0627\u0633\u0631',
    anPipeline: '\u062E\u0637 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A',
    anBySource: '\u062D\u0633\u0628 \u0627\u0644\u0645\u0635\u062F\u0631',
    anTeamComparison: '\u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u0641\u0631\u064A\u0642',
    anWeeklyActivity: '\u0646\u0634\u0627\u0637 \u0627\u0644\u0623\u0633\u0628\u0648\u0639 (\u0639\u0645\u064A\u0644/\u064A\u0648\u0645)',
    anMyProgress: '\u062A\u0642\u062F\u0645\u064A',
    anPeriodToday: '\u0627\u0644\u064A\u0648\u0645',
    anPeriodYesterday: '\u0623\u0645\u0633',
    anPeriodWeek: '\u0647\u0630\u0627 \u0627\u0644\u0623\u0633\u0628\u0648\u0639',
    anPeriodMonth: '\u0647\u0630\u0627 \u0627\u0644\u0634\u0647\u0631',
    anPeriodCustom: '\u0645\u062E\u0635\u0635',
    anDailyPerformance: '\u0623\u062F\u0627\u0621 \u0627\u0644\u064A\u0648\u0645',
    anTotalTasks: '\u0627\u0644\u0645\u0647\u0627\u0645',
    anCompleted: '\u0645\u0646\u062C\u0632',
    anTodayDetail: '\u0645\u0647\u0627\u0645 \u0627\u0644\u064A\u0648\u0645',
    anCompletedTasks: '\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0646\u062C\u0632\u0629',
    anCompletedToday: '\u0627\u0644\u064A\u0648\u0645',
    anCompletedPrevious: '\u0633\u0627\u0628\u0642\u0627\u064B',
    anPendingTasks: '\u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0642\u0629',
    anAllDone: '\u062A\u0645 \u0625\u0646\u062C\u0627\u0632 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0647\u0627\u0645!',
    anVisitScheduled: '\u0645\u0648\u0639\u062F \u0632\u064A\u0627\u0631\u0629 \u0645\u062C\u062F\u0648\u0644',
    anNotInterested: '\u063A\u064A\u0631 \u0645\u0647\u062A\u0645',
    anInterestedNoVisit: '\u0645\u0647\u062A\u0645 \u2014 \u0628\u062F\u0648\u0646 \u0632\u064A\u0627\u0631\u0629',
    anLossReasons: '\u0623\u0633\u0628\u0627\u0628 \u0627\u0644\u062E\u0633\u0627\u0631\u0629',
    anVisitLost: '\u0632\u064A\u0627\u0631\u0629 \u2190 \u062E\u0633\u0627\u0631\u0629',
    hintVisitLost: '\u0639\u0645\u0644\u0627\u0621 \u062A\u0645 \u062C\u062F\u0648\u0644\u0629 \u0632\u064A\u0627\u0631\u0629 \u0644\u0647\u0645 \u062B\u0645 \u062A\u062D\u0648\u0644\u0648\u0627 \u0625\u0644\u0649 \u062E\u0633\u0627\u0631\u0629 \u0641\u064A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629 \u2014 \u0645\u0624\u0634\u0631 \u0639\u062F\u0645 \u062D\u0636\u0648\u0631 \u0623\u0648 \u0641\u0634\u0644 \u0627\u0644\u0632\u064A\u0627\u0631\u0629',
    anStaleLeads: '\u0639\u0645\u0644\u0627\u0621 \u0631\u0627\u0643\u062F\u0648\u0646',
    anCommission: '\u0639\u0645\u0648\u0644\u0629 \u0627\u0644\u0641\u0631\u064A\u0642',
    anRevenue: '\u0627\u0644\u0625\u064A\u0631\u0627\u062F\u0627\u062A',
    anFunnel: '\u0642\u0645\u0639 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A',
    anFunnelCumulative: '\u0642\u0645\u0639 \u0627\u0644\u062A\u062D\u0648\u064A\u0644',
    anFunnelCumulativeHint: '\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0630\u064A\u0646 \u0648\u0635\u0644\u0648\u0627 \u0625\u0644\u0649 \u0643\u0644 \u0645\u0631\u062D\u0644\u0629 \u2014 \u0645\u0639 \u0646\u0633\u0628\u0629 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0628\u064A\u0646 \u0627\u0644\u0645\u0631\u0627\u062D\u0644',
    anConversionOverall: '\u0646\u0633\u0628\u0629 \u0627\u0644\u062A\u062D\u0648\u064A\u0644 \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A\u0629',
    anConversionFromTop: '\u0645\u0646 \u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0639\u0645\u0644\u0627\u0621',
    anConversionStep: '\u0646\u0633\u0628\u0629 \u0627\u0644\u0627\u0646\u062A\u0642\u0627\u0644',
    anWinRate: '\u0645\u0639\u062F\u0644 \u0627\u0644\u0641\u0648\u0632 \u062D\u0633\u0628 \u0627\u0644\u0645\u0635\u062F\u0631',
    hintStale: '\u0639\u0645\u0644\u0627\u0621 \u0641\u064A \u062E\u0637 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A \u0628\u062F\u0648\u0646 \u062A\u063A\u064A\u064A\u0631 \u062D\u0627\u0644\u0629 \u0644\u0623\u0643\u062B\u0631 \u0645\u0646 14 \u064A\u0648\u0645\u064B\u0627 \u2014 \u0635\u0641\u0642\u0627\u062A \u062A\u0645\u0648\u062A \u0628\u0635\u0645\u062A',
    hintCommission: '\u0625\u062C\u0645\u0627\u0644\u064A \u0639\u0645\u0648\u0644\u0629 \u0627\u0644\u0641\u0631\u064A\u0642 (\u0627\u0644\u0645\u063A\u0644\u0642 + \u0627\u0644\u0645\u062F\u064A\u0631) \u0645\u0646 \u0627\u0644\u0635\u0641\u0642\u0627\u062A \u0627\u0644\u0645\u063A\u0644\u0642\u0629 \u0641\u064A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629',
    hintRevenue: '\u0625\u062C\u0645\u0627\u0644\u064A \u0642\u064A\u0645\u0629 \u0627\u0644\u0635\u0641\u0642\u0627\u062A (\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0641\u0639\u0644\u064A) \u0644\u0644\u0635\u0641\u0642\u0627\u062A \u0627\u0644\u0645\u063A\u0644\u0642\u0629 \u0641\u064A \u0627\u0644\u0641\u062A\u0631\u0629 \u0627\u0644\u0645\u062D\u062F\u062F\u0629',
    anRemaining: '\u0645\u062A\u0628\u0642\u064A',
    anTodayAssigned: '\u0645\u0639\u064A\u0651\u0646',
    anEffortAssigned: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0639\u0645\u0644\u0627\u0621',
    anEffortContacted: '\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0647\u0645',
    anEffortAvgTouches: '\u0645\u062A\u0648\u0633\u0637 \u0645\u0631\u0627\u062A \u0627\u0644\u062A\u0648\u0627\u0635\u0644',
    anEffortOnceDropped: '\u062A\u0648\u0627\u0635\u0644 \u0645\u0631\u0629 \u062B\u0645 \u0625\u0647\u0645\u0627\u0644',
    anStillOpen: '\u0645\u0641\u062A\u0648\u062D',
    anEffortOutcome: '\u0639\u062F\u062F \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0648\u0646\u062A\u0627\u0626\u062C\u0647\u0627',
    anEffortOutcomeHint: '\u0643\u0645 \u0639\u0645\u064A\u0644 \u0639\u0646\u062F \u0643\u0644 \u0639\u062F\u062F \u0645\u0646 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0627\u062A \u0646\u0627\u062C\u062D \u0623\u0648 \u0645\u0641\u062A\u0648\u062D \u0623\u0648 \u062E\u0627\u0633\u0631',
    anCommStatsTitle: '\u0646\u0634\u0627\u0637 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0644\u0643\u0644 \u0645\u0648\u0638\u0641',
    anCommStatsHint: '\u0627\u0644\u062A\u0641\u0627\u0639\u0644\u0627\u062A \u0627\u0644\u0645\u0633\u062C\u0644\u0629 \u0641\u064A \u0627\u0644\u0641\u062A\u0631\u0629\u060C \u0648\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0628\u062F\u0648\u0646 \u062A\u0648\u0627\u0635\u0644\u060C \u0648\u0645\u062A\u0648\u0633\u0637 \u0627\u0644\u0645\u0643\u0627\u0644\u0645\u0627\u062A \u0644\u0644\u0646\u062C\u0627\u062D \u0645\u0642\u0627\u0628\u0644 \u0627\u0644\u062E\u0633\u0627\u0631\u0629',
    anCommsLogged: '\u0645\u0633\u062C\u0644\u0629',
    anCommsLeadsTouched: '\u0639\u0645\u0644\u0627\u0621 \u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0647\u0645',
    anSilentLeads: '\u0639\u0645\u0644\u0627\u0621 \u0628\u062F\u0648\u0646 \u062A\u0648\u0627\u0635\u0644',
    anNeverContacted: '\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0647',
    hintNeverContacted: '\u0639\u0645\u0644\u0627\u0621 \u0645\u064F\u0633\u0646\u062F\u0648\u0646 \u0648\u0644\u0627 \u064A\u0632\u0627\u0644\u0648\u0646 \u0645\u0641\u062A\u0648\u062D\u064A\u0646 \u0628\u062F\u0648\u0646 \u0623\u064A \u0645\u0643\u0627\u0644\u0645\u0629 \u0623\u0648 \u0645\u0644\u0627\u062D\u0638\u0629 \u0645\u0633\u062C\u0644\u0629 \u2014 \u0639\u0645\u0644\u0627\u0621 \u0645\u062F\u0641\u0648\u0639\u0648\u0646 \u062F\u0648\u0646 \u0623\u064A \u062A\u0648\u0627\u0635\u0644. \u0627\u0636\u063A\u0637 \u0644\u0631\u0624\u064A\u062A\u0647\u0645.',
    anAvgToWin: '\u0645\u062A\u0648\u0633\u0637 \u2192 \u0646\u062C\u0627\u062D',
    anAvgToLoss: '\u0645\u062A\u0648\u0633\u0637 \u2192 \u062E\u0633\u0627\u0631\u0629',
    anTouchBreakdown: '\u062A\u0648\u0632\u064A\u0639 \u0645\u0631\u0627\u062A \u0627\u0644\u062A\u0648\u0627\u0635\u0644',
    anTouchN1: '\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0631\u0629 \u0648\u0627\u062D\u062F\u0629',
    anTouchN2: '\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0631\u062A\u064A\u0646',
    anTouchN3: '\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 3 \u0645\u0631\u0627\u062A',
    anTouchN4: '\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 4 \u0645\u0631\u0627\u062A',
    anTouchN5: '\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 5+ \u0645\u0631\u0627\u062A',
    anKpiPerDay: '\u0627\u0644\u0647\u062F\u0641 \u0627\u0644\u064A\u0648\u0645\u064A:',
    anTargetLabel: '\u0627\u0644\u0647\u062F\u0641',
    anFollowupQuality: '\u062C\u0648\u062F\u0629 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629',
    anPipeline: '\u0645\u0633\u0627\u0631 \u0627\u0644\u0635\u0641\u0642\u0627\u062A (\u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A)',
    anTodayResults: '\u0646\u062A\u0627\u0626\u062C \u0627\u0644\u064A\u0648\u0645',
    anNoWorkToday: '\u0644\u0627 \u0639\u0645\u0644 \u0627\u0644\u064A\u0648\u0645',
    anTodayBoard: '\u0627\u0644\u064A\u0648\u0645',
    anAllReps: '\u0643\u0644 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646',
    anLeft: '\u0645\u062A\u0628\u0642\u064A',
    pageLeads: '\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0639\u0645\u0644\u0627\u0621',
    crmAdmin: '\u0645\u062F\u064A\u0631',
    crmSales: '\u0645\u0648\u0638\u0641 \u0645\u0628\u064A\u0639\u0627\u062A',
    crmKanbanView: '\u0644\u0648\u062D\u0629',
    crmTableView: '\u062C\u062F\u0648\u0644',
    crmAddLead: '\u0625\u0636\u0627\u0641\u0629 \u0639\u0645\u064A\u0644',
    crmTotalLeads: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0639\u0645\u0644\u0627\u0621',
    crmNewLeads: '\u0639\u0645\u0644\u0627\u0621 \u062C\u062F\u062F',
    crmWonDeals: '\u0635\u0641\u0642\u0627\u062A \u0646\u0627\u062C\u062D\u0629',
    crmConversionRate: '\u0645\u0639\u062F\u0644 \u0627\u0644\u062A\u062D\u0648\u064A\u0644',
    crmLeadName: '\u0627\u0633\u0645 \u0627\u0644\u0639\u0645\u064A\u0644',
    crmPhone: '\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062A\u0641',
    crmEmail: '\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A',
    crmSource: '\u0627\u0644\u0645\u0635\u062F\u0631',
    crmSnapchatType: 'نوع سناب شات',
    crmSnapchatAqar: 'عقار',
    crmSnapchatSiteVisit: 'زار المشروع',
    crmSelectOption: '— اختر —',
    crmCampaign: '\u0627\u0644\u062D\u0645\u0644\u0629 / \u0627\u0633\u0645 \u0627\u0644\u0625\u0639\u0644\u0627\u0646',
    crmProject: '\u0627\u0644\u0645\u0634\u0631\u0648\u0639',
    crmBudget: '\u0627\u0644\u0645\u064A\u0632\u0627\u0646\u064A\u0629',
    crmNotes: '\u0645\u0644\u0627\u062D\u0638\u0627\u062A',
    crmContactHistory: '\u0633\u062C\u0644 \u0627\u0644\u062A\u0648\u0627\u0635\u0644',
    crmNotesHistory: '\u0627\u0644\u0645\u0644\u0627\u062D\u0638\u0627\u062A \u0648\u0627\u0644\u0633\u062C\u0644',
    crmNote: '\u0645\u0644\u0627\u062D\u0638\u0629',
    crmAdCreative: '\u0627\u0644\u0625\u0639\u0644\u0627\u0646',
    crmStatusLabel: '\u0627\u0644\u062D\u0627\u0644\u0629',
    crmAssignedTo: '\u0645\u0639\u064A\u0651\u0646 \u0644\u0640',
    crmCreatedAt: '\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0627\u0633\u062A\u0644\u0627\u0645',
    crmCreatedBy: '\u0623\u0636\u064A\u0641 \u0628\u0648\u0627\u0633\u0637\u0629',
    wizNoVisitReason: '\u0633\u0628\u0628 \u0639\u062F\u0645 \u0627\u0644\u0632\u064A\u0627\u0631\u0629',
    wizNoVisitReasonPlaceholder: '\u0644\u0645\u0627\u0630\u0627 \u0644\u0627 \u064A\u0631\u064A\u062F \u0627\u0644\u0639\u0645\u064A\u0644 \u0632\u064A\u0627\u0631\u0629 \u0627\u0644\u0645\u0634\u0631\u0648\u0639\u061F',
    wizVisitHappened: '\u062A\u0645\u062A \u0627\u0644\u0632\u064A\u0627\u0631\u0629',
    wizVisitHappenedDesc: '\u0627\u0644\u0639\u0645\u064A\u0644 \u0632\u0627\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639',
    wizVisitMissed: '\u0644\u0645 \u062A\u062A\u0645 \u0627\u0644\u0632\u064A\u0627\u0631\u0629',
    wizVisitMissedDesc: '\u0627\u0644\u0639\u0645\u064A\u0644 \u0644\u0645 \u064A\u062D\u0636\u0631',
    wizCustomerOpinion: '\u0631\u0623\u064A \u0627\u0644\u0639\u0645\u064A\u0644 \u0628\u0627\u0644\u0648\u062D\u062F\u0627\u062A',
    wizNextAction: '\u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062A\u0627\u0644\u064A',
    wizRescheduleVisit: '\u0625\u0639\u0627\u062F\u0629 \u062C\u062F\u0648\u0644\u0629 \u0627\u0644\u0632\u064A\u0627\u0631\u0629',
    wizFollowUp: '\u0645\u062A\u0627\u0628\u0639\u0629',
    crmLastUpdate: '\u0622\u062E\u0631 \u062A\u062D\u062F\u064A\u062B',
    crmFilterWorkedOn: '\u062A\u0645 \u0627\u0644\u0639\u0645\u0644 \u0639\u0644\u064A\u0647',
    crmFilterToday: '\u0627\u0644\u064A\u0648\u0645',
    crmFilterYesterday: '\u0623\u0645\u0633',
    crmFilterCustomDate: '\u062A\u0627\u0631\u064A\u062E \u0645\u062E\u0635\u0635',
    crmCreatedFrom: '\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u0646',
    crmCreatedTo: '\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u0646\u0634\u0627\u0621 \u0625\u0644\u0649',
    crmFilterAllDates: '\u0643\u0644 \u0627\u0644\u062A\u0648\u0627\u0631\u064A\u062E',
    crmFilterSource: '\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0635\u0627\u062F\u0631',
    crmFilterCampaign: '\u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    crmFilterStatus: '\u062C\u0645\u064A\u0639 \u0627\u0644\u062D\u0627\u0644\u0627\u062A',
    crmFilterAssigned: '\u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646',
    crmTodayTasks: '\u0645\u0647\u0627\u0645 \u0627\u0644\u064A\u0648\u0645',
    crmMyPortfolio: '\u0645\u062D\u0641\u0638\u062A\u064A',
    crmTodayActual: '\u0645\u0647\u0627\u0645 \u0627\u0644\u064A\u0648\u0645',
    crmBacklog: '\u0645\u0647\u0627\u0645 \u0645\u0639\u0644\u0651\u0642\u0629',
    crmTodayTotal: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u0647\u0627\u0645',
    crmTodayNew: '\u0639\u0645\u0644\u0627\u0621 \u062C\u062F\u062F',
    crmTodayFollowUps: '\u0645\u062A\u0627\u0628\u0639\u0627\u062A',
    crmTodayOverdue: '\u0645\u062A\u0627\u0628\u0639\u0627\u062A \u0641\u0627\u062A\u062A',
    crmTodayBehind: '\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644',
    crmTodayBehindTitle: '\u0639\u0645\u0644\u0627\u0621 \u0642\u062F\u064A\u0645\u0629 \u2014 \u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0623\u0628\u062F\u0627\u064B',
    crmTodayStaleTitle: '\u0639\u0645\u0644\u0627\u0621 \u0631\u0627\u0643\u062F\u0648\u0646 \u2014 \u0628\u0644\u0627 \u0645\u062A\u0627\u0628\u0639\u0629',
    crmTodayBehindHint: '\u0639\u0645\u0644\u0627\u0621 \u062A\u0645 \u062A\u0639\u064A\u064A\u0646\u0647\u0645 \u0648\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0647\u0645',
    crmTouchesHint: '\u0639\u062F\u062F \u0645\u0631\u0627\u062A \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0627\u0644\u0645\u0633\u062C\u0651\u0644\u0629',
    crmTodayOverdueHint: '\u062D\u062F\u062F\u062A \u0645\u0648\u0639\u062F \u0645\u062A\u0627\u0628\u0639\u0629 \u0648\u0644\u0643\u0646\u0647 \u0641\u0627\u062A',
    crmBehindScheduleWarning: 'هذه العملاء تم تعيينهم بالأمس ولم يتم التواصل معهم بعد!',
    crmTodayEmpty: '\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0647\u0627\u0645 \u0644\u0644\u064A\u0648\u0645 \u2014 \u0623\u062D\u0633\u0646\u062A!',
    crmTodayOverdueTitle: '\u0645\u062A\u0627\u0628\u0639\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629 (\u0645\u062A\u0623\u062E\u0631\u0629)',
    crmOverdueVisitsTitle: '\u0632\u064A\u0627\u0631\u0627\u062A \u0645\u0639\u0644\u0651\u0642\u0629 (\u0645\u062A\u0623\u062E\u0631\u0629)',
    crmTodayOverdueTag: '\u0645\u062A\u0623\u062E\u0631',
    crmTodayFollowUpTitle: '\u0645\u062A\u0627\u0628\u0639\u0627\u062A \u0627\u0644\u064A\u0648\u0645',
    crmTodayFollowUpTag: '\u0645\u062A\u0627\u0628\u0639\u0629',
    crmTodayVisits: '\u0632\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u064A\u0648\u0645',
    crmTodayVisitsTitle: '\u0632\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u0645\u0648\u0642\u0639 \u0627\u0644\u064A\u0648\u0645',
    crmTodayNewTitle: '\u0639\u0645\u0644\u0627\u0621 \u062C\u062F\u062F \u0644\u0644\u062A\u0648\u0627\u0635\u0644',
    crmSearchPlaceholder: '\u0628\u062D\u062B \u0628\u0627\u0644\u0627\u0633\u0645 \u0623\u0648 \u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644...',
    crmSelected: '\u0645\u062D\u062F\u062F',
    crmAssignTo: '\u062A\u0639\u064A\u064A\u0646 \u0625\u0644\u0649...',
    crmAssignBtn: '\u062A\u0639\u064A\u064A\u0646',
    crmClearSelection: '\u0625\u0644\u063A\u0627\u0621',
    crmClearFilters: '\u0645\u0633\u062D \u0627\u0644\u0641\u0644\u0627\u062A\u0631',
    crmLeadDetails: '\u062A\u0641\u0627\u0635\u064A\u0644 \u0627\u0644\u0639\u0645\u064A\u0644',
    crmCommunicationLog: '\u0633\u062C\u0644 \u0627\u0644\u062A\u0648\u0627\u0635\u0644',
    crmAddNote: '\u0627\u0643\u062A\u0628 \u0645\u0644\u0627\u062D\u0638\u0629...',
    crmAddComm: '\u0625\u0636\u0627\u0641\u0629',
    crmNoComms: '\u0644\u0627 \u064A\u0648\u062C\u062F \u062A\u0648\u0627\u0635\u0644 \u0628\u0639\u062F',
    crmSaveLead: '\u062D\u0641\u0638',
    crmDeleteLead: '\u062D\u0630\u0641',
    crmStatusHistory: 'سجل تغييرات الحالة',
    crmNoHistory: 'لا توجد تغييرات بعد',
    crmBy: 'بواسطة',
    crmOutcome: 'النتيجة',
    crmOutcome_interested: 'مهتم',
    crmOutcome_not_interested: 'غير مهتم',
    crmOutcome_not_answering: 'لا يرد',
    crmOfferedPrice: 'السعر المعروض',
    crmFinalPrice: 'السعر النهائي',
    crmConfirmDelete: '\u0647\u0644 \u0623\u0646\u062A \u0645\u062A\u0623\u0643\u062F \u0645\u0646 \u062D\u0630\u0641 \u0647\u0630\u0627 \u0627\u0644\u0639\u0645\u064A\u0644\u061F',
    crmYesDelete: '\u0646\u0639\u0645\u060C \u0627\u062D\u0630\u0641',
    crmCancel: '\u0625\u0644\u063A\u0627\u0621',
    crmApprovalStatus: '\u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629',
    crmApproved: '\u0645\u0648\u0627\u0641\u0642 \u0639\u0644\u064A\u0647',
    crmRejected: '\u0645\u0631\u0641\u0648\u0636',
    crmPendingReview: '\u0628\u0627\u0646\u062A\u0638\u0627\u0631 \u0627\u0644\u0645\u0631\u0627\u062C\u0639\u0629',
    crmApprove: '\u0645\u0648\u0627\u0641\u0642\u0629',
    crmReject: '\u0631\u0641\u0636',
    crmCommType_call: '\u0645\u0643\u0627\u0644\u0645\u0629',
    crmCommType_whatsapp: '\u0648\u0627\u062A\u0633\u0627\u0628',
    crmCommType_meeting: '\u0627\u062C\u062A\u0645\u0627\u0639',
    crmCommType_note: '\u0645\u0644\u0627\u062D\u0638\u0629',
    crmAnalytics: '\u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A',
    crmSalesPerformance: '\u0623\u062F\u0627\u0621 \u0641\u0631\u064A\u0642 \u0627\u0644\u0645\u0628\u064A\u0639\u0627\u062A',
    crmPotential: '\u0645\u062D\u062A\u0645\u0644\u064A\u0646',
    crmLostLabel: '\u062E\u0633\u0627\u0631\u0629',
    crmUnassigned: '\u063A\u064A\u0631 \u0645\u0639\u064A\u0646',
    crmPotentialRate: '\u0646\u0633\u0628\u0629 \u0627\u0644\u0645\u062D\u062A\u0645\u0644\u064A\u0646',
    crmAvgResponse: '\u0645\u062A\u0648\u0633\u0637 \u0648\u0642\u062A \u0627\u0644\u0631\u062F',
    crmContactedCount: '\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644',
    crmPipeline: '\u0645\u0633\u0627\u0631 \u0627\u0644\u0639\u0645\u0644\u0627\u0621',
    crmBySource: '\u062D\u0633\u0628 \u0627\u0644\u0645\u0635\u062F\u0631',
    crmMemberComparison: '\u0645\u0642\u0627\u0631\u0646\u0629 \u0627\u0644\u0641\u0631\u064A\u0642',

    crmLossReason: '\u0633\u0628\u0628 \u0627\u0644\u062E\u0633\u0627\u0631\u0629',
    crmSelectReason: '\u0627\u062E\u062A\u0631 \u0627\u0644\u0633\u0628\u0628...',
    crmLossReasonPrefix: '\u0633\u0628\u0628 \u0627\u0644\u062E\u0633\u0627\u0631\u0629',
    crmLossRequired: '\u064A\u0631\u062C\u0649 \u0627\u062E\u062A\u064A\u0627\u0631 \u0633\u0628\u0628 \u0644\u062A\u0639\u064A\u064A\u0646 \u0627\u0644\u0639\u0645\u064A\u0644 \u0643\u062E\u0627\u0633\u0631',
    crmLossPrice: '\u0627\u0644\u0633\u0639\u0631 \u0645\u0631\u062A\u0641\u0639',
    crmLossNoResponse: '\u0644\u0627 \u064A\u0648\u062C\u062F \u0631\u062F \u0645\u0646 \u0627\u0644\u0639\u0645\u064A\u0644',
    crmLossCompetitor: '\u0627\u062E\u062A\u0627\u0631 \u0645\u0646\u0627\u0641\u0633',
    crmLossNotInterested: '\u063A\u064A\u0631 \u0645\u0647\u062A\u0645',
    crmLossTiming: '\u0627\u0644\u0648\u0642\u062A \u063A\u064A\u0631 \u0645\u0646\u0627\u0633\u0628',
    crmLossLocation: '\u0627\u0644\u0645\u0648\u0642\u0639 \u063A\u064A\u0631 \u0645\u0646\u0627\u0633\u0628',
    crmLossOther: '\u0633\u0628\u0628 \u0622\u062E\u0631',
    crmLossOtherPlaceholder: '\u0623\u062F\u062E\u0644 \u0627\u0644\u0633\u0628\u0628...',
    crmLossDetailsPlaceholder: '\u0623\u0636\u0641 \u062A\u0641\u0627\u0635\u064A\u0644 \u0639\u0646 \u0633\u0628\u0628 \u062E\u0633\u0627\u0631\u0629 \u0647\u0630\u0627 \u0627\u0644\u0639\u0645\u064A\u0644...',

    crmStatus_new: '\u062C\u062F\u064A\u062F',
    crmStatus_contacted: '\u062A\u0645 \u0627\u0644\u062A\u0648\u0627\u0635\u0644',
    crmStatus_interested: '\u0645\u0647\u062A\u0645',
    crmStatus_site_visit_scheduled: '\u0632\u064A\u0627\u0631\u0629 \u0645\u062C\u062F\u0648\u0644\u0629',
    crmStatus_site_visit_done: '\u062A\u0645\u062A \u0627\u0644\u0632\u064A\u0627\u0631\u0629',
    crmStatus_offer_sent: '\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0639\u0631\u0636',
    crmStatus_negotiating: '\u062A\u0641\u0627\u0648\u0636',
    crmStatus_won: '\u0646\u0627\u062C\u062D',
    crmStatus_lost: '\u062E\u0627\u0633\u0631',

    // Status Transition Wizard
    wizTitle: '\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062D\u0627\u0644\u0629',
    wizChooseOutcome: '\u0645\u0627 \u0646\u062A\u064A\u062C\u0629 \u0627\u0644\u062A\u0648\u0627\u0635\u0644\u061F',
    wizInterested: '\u0645\u0647\u062A\u0645',
    wizInterestedDesc: '\u0627\u0644\u0639\u0645\u064A\u0644 \u0623\u0628\u062F\u0649 \u0627\u0647\u062A\u0645\u0627\u0645\u0627\u064B \u0628\u0645\u0634\u0631\u0648\u0639',
    wizNotAnswering: '\u0644\u0645 \u064A\u0631\u062F / \u0627\u062A\u0635\u0644 \u0644\u0627\u062D\u0642\u0627\u064B',
    wizNotAnsweringDesc: '\u062C\u062F\u0648\u0644\u0629 \u0645\u0643\u0627\u0644\u0645\u0629 \u0645\u062A\u0627\u0628\u0639\u0629',
    wizNotInterested: '\u063A\u064A\u0631 \u0645\u0647\u062A\u0645',
    wizNotInterestedDesc: '\u0627\u0644\u0639\u0645\u064A\u0644 \u063A\u064A\u0631 \u0645\u0647\u062A\u0645',
    wizWantsToBuy: '\u0645\u0647\u062A\u0645 \u0628\u0627\u0644\u0634\u0631\u0627\u0621',
    wizWantsToBuyDesc: '\u062C\u0627\u0647\u0632 \u0644\u0627\u0633\u062A\u0644\u0627\u0645 \u0639\u0631\u0636',
    wizNeedsTime: '\u064A\u062D\u062A\u0627\u062C \u0648\u0642\u062A',
    wizNeedsTimeDesc: '\u0645\u0647\u062A\u0645 \u0644\u0643\u0646 \u064A\u062D\u062A\u0627\u062C \u0648\u0642\u062A \u0644\u0644\u062A\u0641\u0643\u064A\u0631',
    wizDealWon: '\u0635\u0641\u0642\u0629 \u0646\u0627\u062C\u062D\u0629',
    wizDealWonDesc: '\u0625\u062A\u0645\u0627\u0645 \u0627\u0644\u0635\u0641\u0642\u0629 \u0628\u0646\u062C\u0627\u062D',
    wizContinueNegotiation: '\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0627\u0644\u062A\u0641\u0627\u0648\u0636',
    wizContinueNegotiationDesc: '\u0644\u0627 \u0632\u0627\u0644 \u064A\u062A\u0641\u0627\u0648\u0636 \u0639\u0644\u0649 \u0627\u0644\u0634\u0631\u0648\u0637',
    wizDealLost: '\u0635\u0641\u0642\u0629 \u062E\u0627\u0633\u0631\u0629',
    wizDealLostDesc: '\u0627\u0644\u0639\u0645\u064A\u0644 \u0642\u0631\u0631 \u0639\u062F\u0645 \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629',
    wizSelectProject: '\u0627\u0644\u0645\u0634\u0631\u0648\u0639',
    wizChooseProject: '\u0627\u062E\u062A\u0631 \u0627\u0644\u0645\u0634\u0631\u0648\u0639...',
    wizProject_yamam7: '\u0623\u062F\u0648\u0627\u0631 \u2013 \u064A\u0645\u0627\u0645 7',
    wizProject_yamam8: '\u064A\u0645\u0627\u0645 8',
    wizProject_yamamFlowers8: '\u064A\u0645\u0627\u0645 \u0641\u0644\u0648\u0631\u0632 8',
    wizProject_yamam9: '\u0623\u062F\u0648\u0627\u0631 \u2013 \u064A\u0645\u0627\u0645 9',
    wizProject_yamamPark10: '\u064A\u0645\u0627\u0645 \u0628\u0627\u0631\u0643 10',
    wizProject_yamamPark11: '\u064A\u0645\u0627\u0645 \u0628\u0627\u0631\u0643 11',
    wizProject_yamamFlowers12: '\u064A\u0645\u0627\u0645 \u0641\u0644\u0648\u0631\u0632 12',
    wizProject_yamam13: '\u062A\u0627\u0648\u0646 \u0647\u0627\u0648\u0633 \u2013 \u064A\u0645\u0627\u0645 13',
    wizProject_yamamPark14: '\u064A\u0645\u0627\u0645 \u0628\u0627\u0631\u0643 14',
    wizProject_yamam15: '\u0623\u062F\u0648\u0627\u0631 \u2013 \u064A\u0645\u0627\u0645 15',
    wizProject_yamam16: '\u0623\u062F\u0648\u0627\u0631 \u2013 \u064A\u0645\u0627\u0645 16',
    wizProject_yamam17: '\u0623\u062F\u0648\u0627\u0631 \u2013 \u064A\u0645\u0627\u0645 17',
    wizProject_yamam18: '\u062A\u0627\u0648\u0646 \u0647\u0627\u0648\u0633 \u2013 \u064A\u0645\u0627\u0645 18',
    wizProject_yamam19: '\u0623\u062F\u0648\u0627\u0631 \u2013 \u064A\u0645\u0627\u0645 19',
    wizProject_yamamFlowers: '\u064A\u0645\u0627\u0645 \u0641\u0644\u0648\u0631\u0632',
    wizProject_yamamPark: '\u064A\u0645\u0627\u0645 \u0628\u0627\u0631\u0643',
    wizProject_adwarTaawon: '\u0623\u062F\u0648\u0627\u0631 \u0627\u0644\u062A\u0639\u0627\u0648\u0646',
    wizProject_adwarHiteen: '\u0623\u062F\u0648\u0627\u0631 \u062D\u0637\u064A\u0646',
    wizProject_other: '\u0623\u062E\u0631\u0649',
    wizPaymentMethod: '\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u062F\u0641\u0639',
    wizPayment_cash: '\u0643\u0627\u0634',
    wizPayment_bank: '\u062A\u0645\u0648\u064A\u0644 \u0628\u0646\u0643\u064A',
    wizPayment_installment: '\u062A\u0642\u0633\u064A\u0637',
    wizArrangeVisit: '\u0647\u0644 \u062A\u0631\u064A\u062F \u062A\u0631\u062A\u064A\u0628 \u0632\u064A\u0627\u0631\u0629\u061F',
    wizYes: '\u0646\u0639\u0645',
    wizNo: '\u0644\u0627',
    wizVisitDateTime: '\u062A\u0627\u0631\u064A\u062E \u0648\u0648\u0642\u062A \u0627\u0644\u0632\u064A\u0627\u0631\u0629',
    wizFollowUpDate: '\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629',
    wizLossDetails: '\u0627\u0644\u062A\u0641\u0627\u0635\u064A\u0644',
    wizOfferAmount: '\u0645\u0628\u0644\u063A \u0627\u0644\u0639\u0631\u0636',
    wizOfferedPrice: '\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0645\u0639\u0631\u0648\u0636',
    wizCounterOffer: '\u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u0645\u0642\u0627\u0628\u0644',
    wizFinalPrice: '\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0646\u0647\u0627\u0626\u064A',
    wizUnitNumber: '\u0631\u0642\u0645 \u0627\u0644\u0648\u062D\u062F\u0629',
    wizNextActionDate: '\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0625\u062C\u0631\u0627\u0621 \u0627\u0644\u062A\u0627\u0644\u064A',
    wizOutcome: '\u0627\u0644\u0646\u062A\u064A\u062C\u0629',
    wizNewStatus: '\u0627\u0644\u062D\u0627\u0644\u0629 \u0627\u0644\u062C\u062F\u064A\u062F\u0629',
    wizBack: '\u0631\u062C\u0648\u0639',
    wizReview: '\u0645\u0631\u0627\u062C\u0639\u0629',
    wizConfirm: '\u062A\u0623\u0643\u064A\u062F',
    wizRequired: '\u0647\u0630\u0627 \u0627\u0644\u062D\u0642\u0644 \u0645\u0637\u0644\u0648\u0628',
    wizStatusNote: '\u0645\u0644\u0627\u062D\u0638\u0627\u062A',
    wizStatusNotePlaceholder: '\u0627\u0643\u062A\u0628 \u0645\u0627\u0630\u0627 \u062D\u0635\u0644 \u0645\u0639 \u0647\u0630\u0627 \u0627\u0644\u0639\u0645\u064A\u0644...',
    wizUpdateStatus: '\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062D\u0627\u0644\u0629',
    wizFollowUpDue: '\u0645\u0648\u0639\u062F \u0627\u0644\u0645\u062A\u0627\u0628\u0639\u0629 \u062D\u0627\u0646!',
    wizFollowUpDueDesc: '\u064A\u0631\u062C\u0649 \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639 \u0647\u0630\u0627 \u0627\u0644\u0639\u0645\u064A\u0644 \u0648\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u062D\u0627\u0644\u0629 \u0623\u062F\u0646\u0627\u0647',
    wizFollowUpScheduled: '\u0645\u062A\u0627\u0628\u0639\u0629 \u0645\u062C\u062F\u0648\u0644\u0629',

    // Channels
    navChannels: '\u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    pageChannels: '\u0642\u0646\u0648\u0627\u062A \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    channel_snapchat: '\u0633\u0646\u0627\u0628\u0634\u0627\u062A',
    channel_tiktok: '\u062A\u064A\u0643\u062A\u0648\u0643',
    channel_google: '\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u062C\u0648\u062C\u0644',
    channel_instagram: '\u0625\u0646\u0633\u062A\u063A\u0631\u0627\u0645',
    channel_x: 'X (\u062A\u0648\u064A\u062A\u0631)',
    channelComingSoonDesc: '\u0647\u0630\u0627 \u0627\u0644\u0631\u0628\u0637 \u0642\u064A\u062F \u0627\u0644\u062A\u0637\u0648\u064A\u0631. \u0642\u0645 \u0628\u0631\u0628\u0637 \u062D\u0633\u0627\u0628\u0643 \u0641\u064A \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0639\u0646\u062F \u0627\u0644\u062A\u0648\u0641\u0631.',
    gadsKeywords: '\u0627\u0644\u0643\u0644\u0645\u0627\u062A \u0627\u0644\u0645\u0641\u062A\u0627\u062D\u064A\u0629',
    gadsKeyword: '\u0627\u0644\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0641\u062A\u0627\u062D\u064A\u0629',
    gadsMatchType: '\u0646\u0648\u0639 \u0627\u0644\u0645\u0637\u0627\u0628\u0642\u0629',
    gadsAdGroups: '\u0645\u062C\u0645\u0648\u0639\u0627\u062A \u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A',
    gadsAdGroup: '\u0645\u062C\u0645\u0648\u0639\u0629 \u0625\u0639\u0644\u0627\u0646\u064A\u0629',
    channelDemoData: '\u0628\u064A\u0627\u0646\u0627\u062A \u062A\u062C\u0631\u064A\u0628\u064A\u0629',
    channelDailySpend: '\u0627\u062A\u062C\u0627\u0647 \u0627\u0644\u0625\u0646\u0641\u0627\u0642 \u0627\u0644\u064A\u0648\u0645\u064A',
    channelCampaignPerf: '\u0623\u062F\u0627\u0621 \u0627\u0644\u062D\u0645\u0644\u0627\u062A',
    channelReach: '\u0627\u0644\u0648\u0635\u0648\u0644',
    channelEngagement: '\u0627\u0644\u062A\u0641\u0627\u0639\u0644',
    channelEngRate: '\u0645\u0639\u062F\u0644 \u0627\u0644\u062A\u0641\u0627\u0639\u0644',
    channelLinkClicks: '\u0646\u0642\u0631\u0627\u062A \u0627\u0644\u0631\u0627\u0628\u0637',
    channelSaves: '\u0627\u0644\u062D\u0641\u0638',
    channelShares: '\u0627\u0644\u0645\u0634\u0627\u0631\u0643\u0627\u062A',
    channelRetweets: '\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u062A\u063A\u0631\u064A\u062F',
    channelLikes: '\u0627\u0644\u0625\u0639\u062C\u0627\u0628\u0627\u062A',
    channelFollowers: '\u0645\u062A\u0627\u0628\u0639\u0648\u0646 \u062C\u062F\u062F',
    channelConvRate: '\u0645\u0639\u062F\u0644 \u0627\u0644\u062A\u062D\u0648\u064A\u0644',
    channelQualityScore: '\u062C\u0648\u062F\u0629 \u0627\u0644\u0625\u0639\u0644\u0627\u0646',
    channelType: '\u0627\u0644\u0646\u0648\u0639',
    channelPlacement: '\u0627\u0644\u0645\u0648\u0636\u0639',
    channelObjective: '\u0627\u0644\u0647\u062F\u0641',
    channelCPE: '\u062A\u0643\u0644\u0641\u0629 \u0627\u0644\u062A\u0641\u0627\u0639\u0644',
    channelClicksByCampaign: '\u0627\u0644\u0646\u0642\u0631\u0627\u062A \u062D\u0633\u0628 \u0627\u0644\u062D\u0645\u0644\u0629',
    channelDailyReachEng: '\u0627\u0644\u0648\u0635\u0648\u0644 \u0648\u0627\u0644\u062A\u0641\u0627\u0639\u0644 \u0627\u0644\u064A\u0648\u0645\u064A',
    channelSpendByPlacement: '\u0627\u0644\u0625\u0646\u0641\u0627\u0642 \u062D\u0633\u0628 \u0627\u0644\u0645\u0648\u0636\u0639',
    channelDailyImpEng: '\u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631 \u0648\u0627\u0644\u062A\u0641\u0627\u0639\u0644 \u0627\u0644\u064A\u0648\u0645\u064A',
    channelSpendByObjective: '\u0627\u0644\u0625\u0646\u0641\u0627\u0642 \u062D\u0633\u0628 \u0627\u0644\u0647\u062F\u0641',
    channelEngagements: '\u0627\u0644\u062A\u0641\u0627\u0639\u0644\u0627\u062A',

    // Auth
    loginSubtitle: '\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0644\u0648\u062D\u0629 \u0627\u0644\u062A\u062D\u0643\u0645',
    loginEmail: '\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A',
    loginPassword: '\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631',
    loginButton: '\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644',
    logout: '\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C',
    settingsUserManagement: '\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646',
    settingsAddUser: '\u0625\u0636\u0627\u0641\u0629 \u0645\u0633\u062A\u062E\u062F\u0645',
    settingsCreateUser: '\u0625\u0646\u0634\u0627\u0621 \u0645\u0633\u062A\u062E\u062F\u0645',
    settingsUserCreated: '\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0628\u0646\u062C\u0627\u062D',
    settingsName: '\u0627\u0644\u0627\u0633\u0645',
    settingsRole: '\u0627\u0644\u062F\u0648\u0631',
    settingsRoleAdmin: '\u0645\u062F\u064A\u0631',
    settingsRoleManager: '\u0645\u062F\u064A\u0631 \u0645\u0628\u064A\u0639\u0627\u062A',
    settingsRoleSales: '\u0645\u0648\u0638\u0641 \u0645\u0628\u064A\u0639\u0627\u062A',
    settingsRoleBroker: '\u0648\u0633\u064A\u0637',
    settingsRoleViewer: '\u0639\u0631\u0636 \u0641\u0642\u0637',
    settingsLastLogin: '\u0622\u062E\u0631 \u062F\u062E\u0648\u0644',
    settingsTabEmployees: '\u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646',
    settingsTabBrokers: '\u0627\u0644\u0648\u0633\u0637\u0627\u0621',
    settingsTabSocial: '\u0645\u0646\u0635\u0627\u062A \u0627\u0644\u062A\u0648\u0627\u0635\u0644',
    settingsEmployeeManagement: '\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0648\u0638\u0641\u064A\u0646',
    settingsBrokerManagement: '\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0648\u0633\u0637\u0627\u0621',
    settingsAddBroker: '\u0625\u0636\u0627\u0641\u0629 \u0648\u0633\u064A\u0637',
    settingsCreateBroker: '\u0625\u0646\u0634\u0627\u0621 \u0648\u0633\u064A\u0637',
    settingsBrokerCreated: '\u062A\u0645 \u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u0627\u0644\u0648\u0633\u064A\u0637 \u0628\u0646\u062C\u0627\u062D',
    settingsNoEmployees: '\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0648\u0638\u0641\u064A\u0646 \u0628\u0639\u062F',
    settingsNoBrokers: '\u0644\u0627 \u064A\u0648\u062C\u062F \u0648\u0633\u0637\u0627\u0621 \u0628\u0639\u062F',

    hintStatus: '\u062D\u0627\u0644\u0629 \u0627\u0644\u062D\u0645\u0644\u0629 \u0633\u0648\u0627\u0621 \u0643\u0627\u0646\u062A \u0646\u0634\u0637\u0629 \u0623\u0648 \u0645\u062A\u0648\u0642\u0641\u0629 \u0623\u0648 \u0645\u0646\u062A\u0647\u064A\u0629',
    hintObjective: '\u0647\u062F\u0641 \u0627\u0644\u062D\u0645\u0644\u0629 \u0645\u062B\u0644 \u0627\u0644\u0648\u0639\u064A \u0623\u0648 \u0627\u0644\u0632\u064A\u0627\u0631\u0627\u062A \u0623\u0648 \u0627\u0644\u062A\u062D\u0648\u064A\u0644\u0627\u062A',
    hintStart: '\u062A\u0627\u0631\u064A\u062E \u0628\u062F\u0621 \u062A\u0634\u063A\u064A\u0644 \u0627\u0644\u062D\u0645\u0644\u0629',
    hintImpressions: '\u0625\u062C\u0645\u0627\u0644\u064A \u0639\u062F\u062F \u0645\u0631\u0627\u062A \u0639\u0631\u0636 \u0627\u0644\u0625\u0639\u0644\u0627\u0646 \u0644\u0644\u0645\u0633\u062A\u062E\u062F\u0645\u064A\u0646',
    hintSwipes: '\u0639\u062F\u062F \u0645\u0631\u0627\u062A \u0627\u0644\u0633\u062D\u0628 \u0644\u0644\u0623\u0639\u0644\u0649 (\u0627\u0644\u0646\u0642\u0631\u0627\u062A) \u0639\u0644\u0649 \u0627\u0644\u0625\u0639\u0644\u0627\u0646',
    hintSpend: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u0646\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u062D\u0645\u0644\u0629 \u0628\u0627\u0644\u0631\u064A\u0627\u0644 \u0627\u0644\u0633\u0639\u0648\u062F\u064A',
    hintCTR: '\u0645\u0639\u062F\u0644 \u0627\u0644\u0646\u0642\u0631 \u2014 \u0646\u0633\u0628\u0629 \u0645\u0631\u0627\u062A \u0627\u0644\u0638\u0647\u0648\u0631 \u0627\u0644\u062A\u064A \u0623\u062F\u062A \u0625\u0644\u0649 \u0633\u062D\u0628',
    hintCPM: '\u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0644\u0643\u0644 \u0623\u0644\u0641 \u0638\u0647\u0648\u0631',
    hintCPC: '\u0645\u062A\u0648\u0633\u0637 \u0627\u0644\u062A\u0643\u0644\u0641\u0629 \u0644\u0643\u0644 \u0646\u0642\u0631\u0629 \u0633\u062D\u0628',
    hintFreq: '\u0645\u062A\u0648\u0633\u0637 \u0639\u062F\u062F \u0645\u0631\u0627\u062A \u0645\u0634\u0627\u0647\u062F\u0629 \u0643\u0644 \u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u0644\u0625\u0639\u0644\u0627\u0646',
    hintVideoViews: '\u0625\u062C\u0645\u0627\u0644\u064A \u0645\u0634\u0627\u0647\u062F\u0627\u062A \u0627\u0644\u0641\u064A\u062F\u064A\u0648 (\u062B\u0627\u0646\u064A\u062A\u064A\u0646 \u0623\u0648 \u0623\u0643\u062B\u0631)',

    // AI Report
    aiReportBtn: '\u062A\u0642\u0631\u064A\u0631 \u0630\u0643\u064A',
    aiGenerating: '\u062C\u0627\u0631\u064A \u0627\u0644\u0625\u0646\u0634\u0627\u0621...',

    // Leads Received KPI
    execLeadsReceived: '\u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u064A\u0646',
    execLeadsReceivedDesc: '\u0625\u062C\u0645\u0627\u0644\u064A \u0627\u0644\u0639\u0645\u0644\u0627\u0621 \u0627\u0644\u0645\u0633\u062A\u0644\u0645\u064A\u0646 \u0641\u064A \u0627\u0644\u0646\u0638\u0627\u0645 \u0645\u0646 \u062C\u0645\u064A\u0639 \u0627\u0644\u0645\u0635\u0627\u062F\u0631',
    execCostPerLead: '\u062A\u0643\u0644\u0641\u0629/\u0639\u0645\u064A\u0644',
  },
};

export default translations;
